/* eslint-disable react-hooks/exhaustive-deps */
import API from '@aws-amplify/api';
import { cloneDeep } from 'lodash';
import { useSnackbar } from 'notistack';
import { v4 as uuidv4 } from 'uuid';
import { PropTypes } from 'prop-types';

import { useEffect, useState, useRef } from 'react';
import { useRecoilValue, useRecoilState, useSetRecoilState } from 'recoil';

import { Button, Collapse, List, ListItem, ListItemText, MenuItem, Radio, RadioGroup, Select, TextField, FormControlLabel, IconButton, Popover, Tooltip, Dialog } from '@material-ui/core';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import CloseIcon from '@material-ui/icons/Close';

import Constant from '@/common/constant/Constant';
import LogKibanaConstant from '@/common/constant/LogKibanaConstant';
import localStorageUtil from '@/common/utils/localStorageUtil';
import Utils from '@/common/utils/utils';
import { showLoadingMouse, hideLoadingMouse } from '@/common/utils/CustomCursor';
import { userAtom, userPermissionToViewKnowledgeAtom } from '@/state/atom/userAtom';
import { corporationAtom } from '@/state/atom/corporationAtom';

import {
    multiPanelAtom,
    panelSettingAtom,
    reloadListTicketKnowleadPanel,
    knowledgeViewSelectedAtom,
    listenOnChangeKnowledgeViewSelectedAtom,
    isUsingChatAIAtom
} from '@/state/atom/panelAtom';
import { projectInuseDetailAtom, projectListInCorporationByUserIdAtom, viewKnowledgeProjectSelectedAtom } from '@/state/atom/projectAtom';
import {
    helpdeskTicketLastUserActionAtom,
    knowledgeSearchTagSuggestAtom,
    listOptionViewVisibilityForKnowledgeAtom,
    visibilityForKnowledgeAtom,
    isShowVisibilityKnowledgeAtom,
    publicKnowledgeHitNumberTicketAtom,
    drilldownDataSelectedForLog
} from '@/state/atom/ticketAtom';
import {
    helpdeskDefaultDrillDownDataAtom,
    helpdeskDefaultSelectedOptionAtom,
    helpdeskDrillDownDataAtom,
    helpdeskViewStructureAtom,
    isLoadingHelpdeskDrillDownDataAtom,
    isLoadingProjectInuseDrillDownDataAtom,
    masterKnowledgeHyperLinkAtom,
    projectInuseDefaultDrillDownDataAtom,
    projectInuseDefaultSelectedOptionAtom,
    projectInuseDrillDownDataAtom,
    projectInuseViewStructureAtom,
    knowledTicketNotIncludeAtom,
    knowledgeTicketContainAnyAtom,
    optionsSortAtom,
    destinationPrjIdAtom,
    isLoadingDefaultDrilldownAtom,
} from '@/state/atom/ticketKnowledgeAtom';

import { setPanelSelector, triggerReloadTab, triggerReloadTicketListByPanelType, updatePanelAfterCreateTicketSelector } from '@/state/selector/panelSelector';
import { isManagerByProjectInuseSelector } from '@/state/selector/projectSelector';

import { getTicketById } from '@/service/ticketService';
import { createNewAIChatThread } from '@/service/chatAIService';
import { getPublicAPI } from '@/service/publicService';
import { signOut } from '@/service/authenService';

import DataChangePleaseReloadModal from '@/component/common/modal/DataChangePleaseReloadModal';
import { downloadFileFromS3 } from '@/component/common/FileUploaded';
import LoadingPanel from '@/component/common/LoadingPanel';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';
import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';
import { permissionCreateTicketKnowledge } from '@/component/common/layout/addTicket/handler/AddTicketHandler';
import { getDrilldownItemDataSelected, removeDrillDownSelected } from '@/component/ticketList/handler/KnowledgeTicketHandler';
import AlertDialog from '@/component/ticketList/knowledge/AlertDialog';
import { getFirstProjectWhenOpenChatAI, getVisibilityDefault, isDisplayIconChatAIOnKnowledgeList } from '@/component/common/layout/gNav/handler/MenuHandler';
import { getCategoryListOfProject } from '@/component/project/handler/SettingChatbotHandler.js';

import {
    checkDisplayBtnAddView,
    getCurrentDrilldownData,
    getInitDataOrganizationProject,
    getUseRoleInProject,
    getVisibleWidth,
    handleClickCreateTicketType,
    onSubmitSearchListKnowledge,
    openDrilldownAndDetailSearch,
    removeDrillDownSelectedSearchTimeAgo,
    removeDrillDownSelectedSearchTimeRange,
    autoReloadTicket,
    getListTicketKnowledge,
    hasKnowledgeChatPermissionInChatThread,
    isCheckMethodSimilar,
    isViewAllKnowledgeInCorporation,
    displayTagOfThumbAttach,
    isDisplayIconSearchFileAndPageKnowledge,
    getPreviousViewStructureDefault,
    getListTagFieldOfForm,
    isShowFormEditRangeMulti,
    getDataPublicRange,
    getAllBookmarkUserCanUse,
} from '@/component/ticketKnowledge/handler/ListTicketKnowledgeHandler';
import {
    createNewView,
    getListViews,
    getViewDefaultsChatAI,
    isViewWasChanged,
    onChangeViewSelected,
    onChangeVisibilitySetting,
    onHandlerShowView,
} from '@/component/ticketKnowledge/handler/ViewHandler';
import {
    handleChangeSearchAttribute,
    handleChangeSearchMethod,
    handleChangeSearchPdfOption,
    handleOnChangeSearchSynonym,
    isDisplayOptionSearchSynonymForKnowledgeList
} from '@/component/ticketKnowledge/handler/DrilldownAndDetailSearchHandler';
import { DialogNoticeViewChanged } from '@/component/ticketKnowledge/views/DialogNoticeViewChanged';
import { DialogViewNameError } from '@/component/ticketKnowledge/views/DialogViewNameError';
import DraggableViewsList from '@/component/ticketKnowledge/views/DraggableViewsList';
import SeemoreViewKnowledgeList from '@/component/ticketKnowledge/views/SeemoreViewKnowledgeList';
import BulkAction from '@/component/ticketKnowledge/elements/BulkAction';
import RenderMultiPublicRange from '@/component/ticketKnowledge/elements/RenderMultiPublicRange';
import RenderTagFieldInForm from '@/component/ticketKnowledge/elements/RenderTagFieldInForm';
import RenderExportMenu from '@/component/ticketKnowledge/elements/RenderExportMenu';
import ListKnowledgeItem from '@/component/ticketKnowledge/ListKnowledgeItem';

import './ListTicketKnowledge.css';
import { isLimitedTabsLength } from '@/service/userService';
import SearchInput from './elements/SearchInput';
import { getSelectedProjectDetailById } from '@/service/projectService';
import trI18n from '@/common/utils/trI18n';
import { tr } from '@/common/utils/tr';
import {
    getSelectedDrilldownFieldDisplayLabel,
    getSelectedDrilldownItemDisplayLabel
} from '@/common/utils/DrilldownDisplayUtils';
import { getViewDisplayName } from '@/common/utils/ViewUtils';
import { useTranslationSubscription } from '@/hooks/useTranslation';
import { buildSnackbarMessage } from '@/component/common/SnackbarMessage';

// Labels are wrapped with tr() at set time (see setVisibilitySettingListOption)
// so translation applies after the dictionary has loaded, not at module import.
const listOptionViewVisibilityInitData = [
    {
        value: Constant.VISIBILITY_SETTING_TYPE.PROJECT,
        label: 'プロジェクト内 '
    },
    {
        value: Constant.VISIBILITY_SETTING_TYPE.IN_ORG,
        label: '組織内'
    },
    {
        value: Constant.VISIBILITY_SETTING_TYPE.CUSTOMER,
        label: '一般公開'
    }
];

ListTicketKnowledge.propTypes = {
    panelId: PropTypes.any,
    tabId: PropTypes.any,
    ticketId: PropTypes.any,
    isCustomer: PropTypes.any,
    customerId: PropTypes.any,
    masterKnowledgeHyperLink: PropTypes.any,
    projectSelectedId: PropTypes.any,
    corporationSelectedId: PropTypes.any,
    ticketIdList: PropTypes.any,
    visibilitySettingType: PropTypes.any,
    knowledgeInfoChatAi: PropTypes.any,
    triggerReload: PropTypes.any
};

export default function ListTicketKnowledge(props) {
    // Re-render when the translation dictionary loads/extends so tr() text updates.
    useTranslationSubscription();

    props = {...props, API: API}
    const masterKnowledgeHyperLink = useRecoilValue(masterKnowledgeHyperLinkAtom);

    // common userDetail state
    const userDetail = useRecoilValue(userAtom);
    const userPermissionView = useRecoilValue(userPermissionToViewKnowledgeAtom);

    // common projectInuse state
    const projectInuseDetail = useRecoilValue(projectInuseDetailAtom);
    const [corporationDetail, setCorporationDetail] = useRecoilState(corporationAtom);
    const projectList = useRecoilValue(projectListInCorporationByUserIdAtom);
    const isProjectManager = useRecoilValue(isManagerByProjectInuseSelector);

    // reload panel
    const [isCustomer, setIsCustomer] = useState(props.isCustomer);
    const [customerId, setCustomerId] = useState(props.customerId);
    const [ticketIdList, setTicketIdList] = useState(props.ticketIdList);
    const [masterKnowledgeHyperLinkStatus, setMasterKnowledgeHyperLinkStatus] = useState(props.masterKnowledgeHyperLink);
    const [visibilitySettingType, setVisibilitySettingType] = useState(props.visibilitySettingType);

    // Add new panel
    let addNewPanel = useSetRecoilState(setPanelSelector);

    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingView, setIsLoadingView] = useState(false);

    // ticket knowledge list
    const [ticketKnowledgeList, setTicketKnowledgeList] = useState([]);

    const [addViewPopover, setAddViewPopover] = useState(null);
    const isOpenFormTypePopover = Boolean(addViewPopover);
    const id = isOpenFormTypePopover ? 'simple-popover' : undefined;
    const [panelList, setPanelList] = useRecoilState(multiPanelAtom);
    const [createTicketTypePopover, setCreateTicketTypePopover] = useState(null);
    const [viewSelected, setViewSelected] = useState({});
    const [listView, setListView] = useState([]);

    const [openListViewHide, setOpenListViewHide] = useState(false);
    const [organizationSelected, setOrganizationSelected] = useState({});
    const [projectSelected, setProjectSelected] = useState({});

    const [projectSelectedId, setProjectSelectedId] = useState(props.projectSelectedId ? props.projectSelectedId : projectInuseDetail.id);
    const [viewKnowledgeProjectSelected, setViewKnowledgeProjectSelected] = useRecoilState(viewKnowledgeProjectSelectedAtom);

    
    const [corporationSelectedId, setCorporationSelectedId] = useState(props.corporationSelectedId ? props.corporationSelectedId : corporationDetail.id);
    
    const [organizationProject, setOrganizationProject] = useState({});
    
    const setVisibilitySettingListOption = useSetRecoilState(
        listOptionViewVisibilityForKnowledgeAtom
    );
    const [userRoleInProject, setUserRoleInProject] = useState('');

    const [viewStructure, setViewStructure] = useRecoilState(
        isCustomer ? helpdeskViewStructureAtom : projectInuseViewStructureAtom
    );

    const [drilldownDataSelected, setDrillDownDataSelected] = useState([]);
    const setDrillDownDataForLog = useSetRecoilState(drilldownDataSelectedForLog);
    
    // option-search state
    const [keywordSearch, setKeywordSearch] = useState(viewStructure.keyword);
    const [triggerSearch, setTriggerSearch] = useState('');
    const [optionSearchTimeRange, setOptionSearchTimeRange] = useState('');
    const [optionSearchTimeAgo, setOptionSearchTimeAgo] = useState('');
    const [destinationPrjId, setDestinationPrjId] = useRecoilState(destinationPrjIdAtom);

    const setDefaultSelectedOption = useSetRecoilState(
        isCustomer ? helpdeskDefaultSelectedOptionAtom : projectInuseDefaultSelectedOptionAtom
    );


    const [isOpenDialogViewNameError, setIsOpenDialogViewNameError] = useState(false);
    const [isOpenDialogViewChanged, setIsOpenDialogViewChanged] = useState(false);
    const [viewNameErrorType, setViewNameErrorType] = useState('');
    const inputViewNameRef = useRef();
    const inputKeyWordRef = useRef();

    // DrillDown data
    const setIsLoadingDrillDown = useSetRecoilState(
        isCustomer ? isLoadingHelpdeskDrillDownDataAtom : isLoadingProjectInuseDrillDownDataAtom
    );
    const setIsLoadingDefaultDrilldown = useSetRecoilState(isLoadingDefaultDrilldownAtom);
    const [drillDownData, setDrillDownData] = useRecoilState(
        isCustomer ? helpdeskDrillDownDataAtom : projectInuseDrillDownDataAtom
    );
    const [sugguestionList, setSugguestionList] = useState([]);
    const [settingSlideRecoilState, setSettingSlideRecoilState] = useRecoilState(panelSettingAtom);
    const [defaultDrillDownData, setDefaultDrillDownData] = useRecoilState(
        isCustomer ? helpdeskDefaultDrillDownDataAtom : projectInuseDefaultDrillDownDataAtom
    );

    const [visibilityKnowledgeAtom, setVisibilityKnowledgeAtom] = useRecoilState(
        visibilityForKnowledgeAtom
    );
    const setIsShowVisibilityKnowledgeAtom = useSetRecoilState(isShowVisibilityKnowledgeAtom);

    // footprint opover
    const [footPrintPopover, setFootPrintPopover] = useState(null);
    const openPopoverFootPrint = Boolean(footPrintPopover);
    const idPopOverFootPrint = openPopoverFootPrint ? 'simple-popover' : undefined;
    const [userFootprintList, setUserFootprintList] = useState([]);

    //share status
    const [shareStatusPopover, setShareStatusPopover] = useState(null);
    const [openShareStatusPopover, setOpenShareStatusPopover] = useState('');
    const idPopoverShareStatus = openShareStatusPopover ? 'simple-popover' : undefined;
    const [shareStatusData, setShareStatusData] = useState([]);
    const reloadTicketListByPanelType = useSetRecoilState(triggerReloadTicketListByPanelType);
    const reloadTabItemInPanel = useSetRecoilState(triggerReloadTab);
    const { enqueueSnackbar } = useSnackbar();
    const [isOpenAlertDialog, setIsOpenAlertDialog] = useState(false);
    const [triggerInterval, setTriggerInterval] = useState('');
    const nodeListView = document.querySelectorAll('.item-knowledge');
    const element = document.querySelector('#container-knowledge');

    const [pagination, setPagination] = useState({ from: 0, size: 20, lastTotal: 0 });
    const [reloadPanelId, setReloadPanelId] = useRecoilState(reloadListTicketKnowleadPanel);
    const [isOpenModalReloadPage, setIsOpenModalReloadPage] = useState(false);
    const [contentModalReloadPage, setContentModalReloadPage] = useState(trI18n('COMMSG030'));
    const [totalTickets, setTotalTickets] = useRecoilState(publicKnowledgeHitNumberTicketAtom);

    const [removedTagItem, setRemovedTagItem] = useState({});
    const [lastUserAction, setLastUserAction] = useRecoilState(helpdeskTicketLastUserActionAtom)
    const [searchTagSuggestKnowledge, setSearchTagSuggestKnowledge] = useRecoilState(knowledgeSearchTagSuggestAtom)
    
    const searchContentType = LogKibanaConstant.CONTENT_TYPES_TICKET.KNOWLEDGE;
    const searchContainAnyKnowledge = useRecoilValue(knowledgeTicketContainAnyAtom);
    const searchNotIncludeKnowledge = useRecoilValue(knowledTicketNotIncludeAtom);
    const isKnowledge = true;
    const [optionsSort, setOptionsSort] = useRecoilState(optionsSortAtom);

    const [isDisplayIconChatAI, setIsDisplayIconChatAI] = useRecoilState(isUsingChatAIAtom);

    const setAtomKnowledgeViewSelected = useSetRecoilState(knowledgeViewSelectedAtom);
    const setListenOnChangeKnowledgeViewSelected = useSetRecoilState(listenOnChangeKnowledgeViewSelectedAtom);
    
    const [isIsnitData, setIsInitData] = useState(false);

    const [isConvertPdf , setIsConvertPdf] = useState(false);

    const [knowledgeInfoChatAi, setKnowledgeInfoChatAi] = useState(props?.knowledgeInfoChatAi ? props?.knowledgeInfoChatAi : null);
    const [isScrollNewViews, setIsScrollNewViews] = useState(false);
    const [fileNamePdfSelect, setFileNamePdfSelect] = useState('');
    const [isIncludeAttachPdf, setIsIncludeAttachPdf] = useState();
    const [previousViewStructure, setPreviousViewStructure] = useState(getPreviousViewStructureDefault(knowledgeInfoChatAi, viewStructure));
    const [isSearchSynonym,setIsSearchSynonym] = useState();
    const [isDisableSimilarSearch,setIsDisableSimilarSearch] = useState(false);
    const [isDisableSynonymSearch,setIsDisableSynonymSearch] = useState(false);
    const [isDisableIncludeAttachPdf, setIsDisableIncludeAttachPdf] = useState(false);

    // bulk-action state
    const [currentSearchParams, setCurrentSearchParams] = useState({});
    const [isHasEditPermissionSomeTicket, setIsHasEditPermissionSomeTicket] = useState(false);
    const [isShowEditRangeMulti, setIsShowEditRangeMulti] = useState(false);
    const [isShowExportMenu, setIsShowExportMenu] = useState(false);

    const [listAdditionalAllRole, setListAdditionalAllRole] = useState([]);
    const [listDataPublicRange, setListDataPublicRange] = useState({});

    const [isShowEditTagFields,setIsShowEditTagField] = useState(false);
    const [listTagFieldOfForm,setListTagFieldOfForm] = useState([]);    
    const [selectedFormId, setSelectedFormId] = useState('')
    const [isLoadDataForPublicRangeDone, setIsLoadDataForPublicRangeDone] = useState(false);
    const [isShowDialogNotiLimit, setIsShowDialogNotiLimit] = useState(false);
    const [isShowDialogReload,setIsShowDialogReload] = useState(false)
    const [msgInProcessingIcon, setMsgInProcessingIcon] = useState("");
    const [loadingBulkItemListTagField,setLoadingBulkItemListTagField] = useState(false);
    const [limitNotiMessage, setLimitNotiMessage] = useState('');
    const [selectedFilterForm,setSelectedFilterForm] = useState({})
    const [isOpenDialogConfirm, setIsOpenDialogConfirm] = useState({
        status: false,
        action: '',
        params: {}
    });
    
    const [triggerReloadListView, setTriggerReloadListView] = useState('');
    const [isViewDelete, setIsViewDelete] = useState(false)
    const [chatbotCategories, setChatbotCategories] = useState([])
    const [isShowPopupLogout, setIsShowPopupLogout] = useState(false);
    const [clickTimeout, setClickTimeout] = useState(null);
    const [scrollToViewFunction, setScrollToViewFunction] = useState(null);

    const [openPreviewImage, setOpenPreviewImage] = useState(null);
    const [isDisplayDestinationPrjBreadCrumbState, setIsDisplayDestinationPrjBreadCrumbState] = useState(true)
    const lastSearchTagSuggestKnowledgeRef = useRef(searchTagSuggestKnowledge);
    const lastUserActionRef = useRef(lastUserAction);

    useEffect(() => {
        lastSearchTagSuggestKnowledgeRef.current = searchTagSuggestKnowledge;
    }, [searchTagSuggestKnowledge]);

    useEffect(() => {
        lastUserActionRef.current = lastUserAction;
    }, [lastUserAction]);

    useEffect(() => {
        const fields = viewStructure.fields;
        const isSelectForm = fields?.find(field => {
           return !Utils.isEmptyString(field.form)
        });
        if(!isSelectForm){
            setIsShowEditTagField(false)
            setIsShowExportMenu(false)
        }
        setIsIncludeAttachPdf(viewStructure?.options?.isIncludeAttachPdf === 1);
        setIsSearchSynonym(viewStructure?.options?.isSearchSynonym === 1);
        if(viewStructure?.options?.isSearchSynonym !== 1){
            setIsDisableSimilarSearch(false)
        }

        const method = viewStructure?.options?.method;
        const isMethodSimilar = method && method === Constant.SETTING_SEARCH_KEYWORD.SIMILAR;
        const isOptionSearchSynonym = viewStructure?.options?.isSearchSynonym === 1;

        setIsDisableSynonymSearch(isMethodSimilar && !isOptionSearchSynonym);
        setIsDisableIncludeAttachPdf(isMethodSimilar && !isOptionSearchSynonym);
        setIsDisableSimilarSearch(!isMethodSimilar && isOptionSearchSynonym);

        if (viewStructure?.options?.filePdfId) {
            //&& viewStructure?.options?.filePdfId !== previousViewStructure?.options?.filePdfId) {
            (async () => {
                let params = {
                    getApiType: Constant.GET_API_PUBLIC_TYPE.GET_OUTLINE_FIELD,
                    ticketId: viewStructure?.options?.filePdfId
                };
            
                let result = await getPublicAPI(props?.API, params);
                if (result.success) {
                    let data = Utils.convertJSONDataToObject(result.payload);
                    setFileNamePdfSelect(data);
                }
            })();
        } else {
            setFileNamePdfSelect('');
        }

    },[viewStructure]);

    
    useEffect(() => {
        let listSystemPdfField = drilldownDataSelected?.filter(item => {
            return item.isPdfSystemFile ? true : false;
        });
        let tagFields = cloneDeep(viewStructure.tagFields);
        let isEnablePdf = checkIsEnablePdfFunction();
        if (!isEnablePdf) {
            listSystemPdfField?.forEach(drillDownItem => {
                tagFields = tagFields?.filter(item => {
                    if (item.hasOwnProperty(drillDownItem.id)) {
                        return false;
                    }

                    return true;
                });
            });
            let newViewStructure = cloneDeep(viewStructure);
            newViewStructure.tagFields = tagFields;
            setViewStructure(newViewStructure)

        }
        setDrillDownDataForLog(drilldownDataSelected)
    }, [drilldownDataSelected]);


    const checkIsEnablePdfFunction = () => {
        let isEnablePdf = false;
        if([Constant.CORPORATION_CONTRACT_TYPE.GUEST,Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK].includes(corporationDetail.contractType)){
            const inviterSetting = Utils.convertJSONDataToObject(corporationDetail.inviterSetting);
            isEnablePdf = inviterSetting.convertPDF;
        }else{
            isEnablePdf = corporationDetail?.limitValue?.convertPDF
        }

        return isEnablePdf == 1
    }

    const closeIconBreadCrumb = () => {
        setFileNamePdfSelect('');
        setViewStructure(previousViewStructure);
        setPreviousViewStructure(previousViewStructure);
        setTriggerSearch(Date.now().toString());
    }

    const isShowIconBreadCrumb = () => {
        return fileNamePdfSelect && isConvertPdf
    }

    // argsCommon
    let argsCommon = {
        ...props,
        createTicketTypePopover,
        setCreateTicketTypePopover,
        settingSlideRecoilState,
        setSettingSlideRecoilState,
        nodeListView,
        element,
        setIsOpenModalReloadPage: setIsOpenModalReloadPage,
        setContentModalReloadPage,
        API: props?.API,
        userDetail: userDetail,
        projectInuseDetail,
        pagination,
        setPagination,
        isLoading: isLoading,
        setIsLoading: setIsLoading,

        isLoadingView,
        setIsLoadingView,

        ticketKnowledgeList: ticketKnowledgeList,
        setTicketKnowledgeList: setTicketKnowledgeList,

        updatePanelAfterCreateTicket: useSetRecoilState(updatePanelAfterCreateTicketSelector),
        addNewPanel,

        projectSelectedId: projectSelectedId,
        corporationSelectedId: corporationSelectedId,
        organizationProject,
        setOrganizationProject,
        organizationSelected,
        setOrganizationSelected,
        projectSelected,
        setProjectSelected,
        // visibilitySetting,
        // setVisibilitySetting,
        viewSelected,
        setViewSelected,
        listView,
        setListView,
        userRoleInProject,
        setUserRoleInProject,
        openListViewHide,
        setOpenListViewHide,

        viewStructure,
        setViewStructure,
        drilldownDataSelected,
        setDrillDownDataSelected,

        keywordSearch,
        setKeywordSearch,

        setTriggerSearch,

        isCustomer: isCustomer,
        customerId: customerId,
        panelId: props.panelId,

        panelList,
        setPanelList,
        setAddViewPopover,

        setOptionSearchTimeRange,

        setOptionSearchTimeAgo,

        isOpenDialogViewNameError,
        setIsOpenDialogViewNameError,
        isOpenDialogViewChanged,
        setIsOpenDialogViewChanged,

        viewNameErrorType,
        setViewNameErrorType,
        inputViewNameRef,

        drillDownData,
        setDrillDownData,
        defaultDrillDownData,
        setDefaultDrillDownData,

        sugguestionList,
        setSugguestionList,
        inputKeyWordRef,

        // share status
        shareStatusPopover,
        setShareStatusPopover,
        openShareStatusPopover,
        idPopoverShareStatus,
        setOpenShareStatusPopover,
        shareStatusData,
        setShareStatusData,
        reloadTicketListByPanelType,
        reloadTabItemInPanel,
        isOpenAlertDialog,
        setIsOpenAlertDialog,

        ticketIdList: ticketIdList,
        enqueueSnackbar,
        setTotalTickets,
        lastUserAction,
        setRemovedTagItem,
        setLastUserAction,
        setSearchTagSuggestKnowledge,
        searchTagSuggestKnowledge,
        searchContainAnyKnowledge,
        searchNotIncludeKnowledge,
        isKnowledge,
        corporationDetail,
        optionsSort,
        setOptionsSort,
        setCorporationDetail,
        setIsDisableSimilarSearch,
        setIsDisableSynonymSearch,
        setFileNamePdfSelect,
        visibilityKnowledgeAtom,
        isIncludeAttachPdf,
        setIsIncludeAttachPdf,
        setIsDisableIncludeAttachPdf,
        setCurrentSearchParams,
        // setIsHasEditPermissionEveryTicket,
        setIsHasEditPermissionSomeTicket,
        setListAdditionalAllRole,
        setListDataPublicRange,
        setIsLoadDataForPublicRangeDone,

        destinationPrjId,
        setDestinationPrjId,
        chatbotCategories,

        showLoadingMouse,
        setTriggerReloadListView
    };

    // init data organization project
    const initDataOrganizationProject = async () => {
        try {
            setIsLoadingView(true);

                if (Utils.isEmptyObject(organizationProject)) {
                    setIsLoadingView(false);
                    return;
                }

                let visibility = '';
                if (organizationProject.value !== Constant.KNOWLEDGE_VIEW_OPTION.PRJ_IN_USE) {
                    visibility = Constant.VISIBILITY_SETTING_TYPE.CUSTOMER;
                    if (organizationProject.corpId === corporationDetail.id && !Utils.isB2CUser(userDetail)) {
                        visibility = Constant.VISIBILITY_SETTING_TYPE.IN_ORG;
                    }
                } else {
                    const isOpenFromChatAI =  !Utils.isEmptyObject(props.knowledgeInfoChatAi);
                    if(isOpenFromChatAI) {
                        visibility = props?.visibilitySettingType ?  props?.visibilitySettingType : Constant.VISIBILITY_SETTING_TYPE.PROJECT;
                    } else {
                        visibility = Constant.VISIBILITY_SETTING_TYPE.PROJECT;
                    }
                    //Check role user in projectSelected

                    await getUseRoleInProject(argsCommon, userDetail.id, projectSelectedId);
                    setVisibilitySettingListOption(
                        listOptionViewVisibilityInitData.map(option => ({
                            ...option,
                            label: tr(option.label)
                        }))
                    );
                    setVisibilityKnowledgeAtom(visibility);
                }
    
                let listViewRes = await getListViews(argsCommon, projectSelectedId, visibility, knowledgeInfoChatAi, setIsScrollNewViews);
                setKnowledgeInfoChatAi(null);
                if(props.isOpenFromChatAI) {
                    let projectSelectedKnowledgeId = await getFirstProjectWhenOpenChatAI(props?.API, userDetail, corporationDetail, projectInuseDetail);
                    let [listViews, projectSelectedDetail] = await Promise.all([getViewDefaultsChatAI(props?.API, projectSelectedKnowledgeId, userDetail), getSelectedProjectDetailById(props?.API, projectSelectedKnowledgeId, projectInuseDetail)]);
                    let firstView = {};
                    let structure = {};
                    if(!Utils.isEmpty(listViews)) {
                        firstView = listViews[0];
                        let visibilityDefault = getVisibilityDefault(corporationDetail, projectInuseDetail)
                        structure = Utils.convertJSONDataToObject(firstView?.structure);
                        structure.visibility = visibilityDefault;
                    }

                    if(projectSelectedKnowledgeId === Constant.KNOWLEDGE_VIEW_OPTION.ALL_KNOWLEDGE_IN_ORG) {
                        let visibilityFirstView = Constant.VISIBILITY_SETTING_TYPE.CUSTOMER;
                        if (organizationProject.corpId === corporationDetail.id && !Utils.isB2CUser(userDetail)) {
                            visibilityFirstView = Constant.VISIBILITY_SETTING_TYPE.IN_ORG;
                        }
                        firstView ={
                            structure: {
                                ...Constant.DEFAULT_VIEW_STRUCTURE,
                                visibility: visibilityFirstView
                            }
                        }
                    }

                    let propsClone = {...props};
                    delete propsClone.panelId;
                    const newThreadId = `ai_chat_thread_${uuidv4()}`;
                    const filterKnowledgeListData = {
                        viewSelectedId: firstView?.id,
                        viewSelected: firstView,
                        viewStructure: Utils.convertJSONDataToObject(firstView?.structure),
                        projectIdKnowledgeSelected: projectSelectedKnowledgeId,
                        resetSearchCondition: true,
                        usingBasicPrompt: true,
                        isInvalidPrecondition: false,
                        threadId: newThreadId,
                        chatThreadId: newThreadId,
                        projectSelectedId: projectSelectedId,
                        hitNumber: totalTickets,
                        ticketCreatedCorporationId: !Utils.isEmptyArray(listViews) ? projectSelectedDetail?.affiliationOrganization : corporationDetail?.id
                    }
                    const chatThreadDto = {
                        id: newThreadId,
                        chatThreadId: newThreadId,
                        corporationId: corporationDetail.id,
                        affiliationProject: projectSelectedKnowledgeId,
                        clientUUId: `client_uuid_${uuidv4()}`,
                        creatorId: userDetail.id,
                        metaData: { filterKnowledgeListData: JSON.stringify(filterKnowledgeListData) }
                    }

                    let currentPanelList = cloneDeep(panelList);
                    if (Utils.isEmptyArray(currentPanelList)) return;
                    let currentPanelIndex = Utils.findIndexInArrayById(props.panelId, currentPanelList);
                    if (currentPanelIndex === -1) return;

                    let currentPanel = currentPanelList[currentPanelIndex];

                    if (Utils.isEmptyArray(currentPanel.tabList)) return;
                    // Update ticket outline
                    currentPanelList[currentPanelIndex].tabList[
                        0
                    ].component.props.isOpenFromChatAI = false;
                    setPanelList([...currentPanelList]);
            
                    const panelDataChatAI = panelList?.find(
                        panel => panel?.type === Constant.PANEL_TYPE.OPEN_CHAT_AI
                    );
                    const isLimited = await isLimitedTabsLength({
                        panelDataChatAI,
                        projectInuseDetail,
                        userDetail
                    });
                    if (isLimited) {
                        enqueueSnackbar(buildSnackbarMessage('MSG-CM-WARNING-LIMIT-TAB'), {
                            variant: 'error',
                            autoHideDuration: 3000,
                            style: { whiteSpace: 'pre-line' }
                        });
                        const tabList = panelDataChatAI?.tabList || [];
                        if (!Utils.isEmptyArray(tabList) && !panelDataChatAI?.isDisplay) {
                            const lastTab = tabList[tabList.length - 1];
                            addNewPanel({
                                type: Constant.PANEL_TYPE.OPEN_CHAT_AI,
                                tabId: lastTab.id,
                                filterKnowledgeListData: {
                                    ...filterKnowledgeListData,
                                    threadId: lastTab.chatThreadId,
                                    chatThreadId: lastTab.chatThreadId
                                },
                                chatThreadId: lastTab.chatThreadId,
                                props: propsClone
                            });
                        }
                        hideLoadingMouse();
                    } else {
                        const newThreadChat = await createNewAIChatThread(chatThreadDto);
                        if (!Utils.isEmptyObject(newThreadChat)) {
                            let tabId = `${Constant.TAB_PANEL_TYPE.NEW_TAB_CHAT_AI}_${Date.now().toString()}`;
                            addNewPanel({
                                type: Constant.PANEL_TYPE.OPEN_CHAT_AI,
                                tabId: tabId,
                                filterKnowledgeListData: filterKnowledgeListData,
                                chatThreadId: newThreadId,
                                props: propsClone
                            });
                        }
                    }
                }

                if (Utils.isEmptyArray(listViewRes)) {
                    setListView([]);

                    if (
                        projectSelectedId === Constant.KNOWLEDGE_VIEW_OPTION.ALL_KNOWLEDGE_IN_ORG &&
                        !Utils.isEmptyObject(knowledgeInfoChatAi?.viewStructure)
                    ) {
                        setViewStructure(knowledgeInfoChatAi?.viewStructure);
                    } else {
                        setViewStructure({
                            ...Constant.DEFAULT_VIEW_STRUCTURE,
                            visibility: visibility
                        });
                    }

                }

            setIsLoadingView(false);
        } catch (error) {
            setIsLoadingView(false);
            console.log('initDataOrganizationProject >>>', error);
        }
    };

    // Check convertPdf in CorpRoot by selectedProject
    useEffect(() => {
        if (!Utils.isEmptyObject(viewKnowledgeProjectSelected)) {
            (
                async () => await Utils.isUsingFunctionService(
                    viewKnowledgeProjectSelected,
                    corporationDetail,
                    'convertPDF',
                    setIsConvertPdf
                )
            ) ()
        }
      
    }, [viewKnowledgeProjectSelected]);
      

    useEffect(() => {
        autoScrollToActiveTab();
    },[panelList, element, nodeListView]);

    const formIdSearchConditionFilterBy = () => {
        const fields = !Utils.isEmptyArray(viewStructure?.fields) ? viewStructure?.fields : [];
        const indexOfSelectedForm = fields?.find(field => {
            return !Utils.isEmptyString(field?.form)
        });

        return indexOfSelectedForm && indexOfSelectedForm['form'] ? indexOfSelectedForm['form'] : '';
    }

    
    // Check convertPdf in CorpRoot by selectedProject
    useEffect(() => {
        if (!isHasEditPermissionSomeTicket) return;
        if (!drillDownData || Utils.isEmptyArray(drillDownData)) return;
        const controller9 = new AbortController();
        initDataForBulkActionTagField()
        
        return () => {
            controller9.abort();
        }
    }, [drillDownData, isHasEditPermissionSomeTicket, viewStructure?.fields?.length, destinationPrjId]);

    const initDataForBulkActionTagField = async () => {
        let allTagFieldForBulkAction = [];
        let promiseGetData = [getAllBookmarkUserCanUse(userDetail.id, projectInuseDetail.id, Constant.BOOKMARK_TARGET_TYPE.KNOWLEDGE)];

        setLoadingBulkItemListTagField(true);

        let selectedForm = drillDownData?.find(drillDownDataItem => {
            return drillDownDataItem.id === 'form';
        });

        if (!Utils.isEmptyObject(selectedForm) && formIdSearchConditionFilterBy() && isHasEditPermissionSomeTicket) {
            const child = selectedForm.child;
            if (child && child.length === 1) {
                const formId = child[0]?.id;
                if (formId !== selectedFormId) {
                    setSelectedFormId(formId);
                }
                if(!Utils.isEmptyString(formId)) {
                    promiseGetData.push(
                        getListTagFieldOfForm({
                            formId,
                            userDetail,
                            projectInuseDetail,
                            corporationDetail,
                            setSelectedFilterForm,
                            affiliationProjectId: destinationPrjId,
                            isProjectManager,
                            viewStructure
                        })
                    );
                }
            }
        }

        let getDataTagResponse = await Promise.all(promiseGetData);
        
        let listTagField = getDataTagResponse[1];
        if (listTagField && !Utils.isEmptyArray(listTagField)) {
            listTagField.forEach(tagField => {
                let fieldata = {
                    ...tagField,
                    name: Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, tagField.name)
                };
                allTagFieldForBulkAction.push(fieldata);
            })
        }

        let allBookmark = getDataTagResponse[0];
        if (allBookmark && !Utils.isEmptyArray(allBookmark)) {
            allBookmark = Utils.sortListByNameDictionaryASC(allBookmark);
            allTagFieldForBulkAction.push({
                id: [Constant.FORMAT_OPTION_SEARCH.PRIVATE_BOOKMARK, Constant.FORMAT_OPTION_SEARCH.SHARED_BOOKMARK],
                name: trI18n('BOOKMARK_TAG'),
                listItem: allBookmark,
                isBookmark: true
            })
        }
        setListTagFieldOfForm([...allTagFieldForBulkAction]);

        setLoadingBulkItemListTagField(false)
    }

    const autoScrollToActiveTab = () => {
        if (!element || !nodeListView || Utils.isEmptyArray(nodeListView)) return;
        let nodeListViews = document.querySelectorAll('.item-knowledge');
        if(!Utils.isEmptyArray(nodeListViews)) {
            if(isScrollNewViews) {
                let containerRect = element.getBoundingClientRect();
                let posElem = [];
                for (let i = 0; i < nodeListView.length; i++) {
                    // Gets the amount of pixels currently visible within the container
                    let visiblePageWidth = getVisibleWidth(nodeListView[i]);
                    posElem.push({ pos: visiblePageWidth });
                }
                element.scrollLeft +=
                    posElem[posElem.length - 1].pos.width -
                    (containerRect.width - posElem[posElem.length - 1].pos.left);
                setIsScrollNewViews(false);
            }
        }
    }

    const clearMemoryLoadTicketList = () => {
        argsCommon = {};
        addNewPanel = {};
        setTicketIdList([]);
        setTicketKnowledgeList([]);
        setIsLoadingView(false);
        setOrganizationSelected({});
        setProjectSelected({});
        setOrganizationProject({});
        setDrillDownDataSelected([]);
        setDrillDownData([]);
        setDefaultDrillDownData([]);
        setUserFootprintList([]);
        setShareStatusData([]);
        setSearchTagSuggestKnowledge([]);
        setKnowledgeInfoChatAi({});

        setViewSelected({});
        setListView([]);
        setListTagFieldOfForm([]);
    }

    useEffect(() => {
        const controller1 = new AbortController();
        (async () => {
            if (!userPermissionView || Utils.isEmptyObject(userPermissionView)) return;
            try {
                const isOpenFromChatAI =  !Utils.isEmptyObject(props.knowledgeInfoChatAi);

                setIsInitData(true);
                //get data organizationProject;
                const organizationRes = await getInitDataOrganizationProject(
                    props?.API,
                    userPermissionView,
                    projectInuseDetail,
                    corporationDetail,
                    setVisibilityKnowledgeAtom,
                    setIsShowVisibilityKnowledgeAtom,
                    setProjectSelectedId,
                    setViewKnowledgeProjectSelected,
                    setCorporationSelectedId,
                    projectSelectedId,
                    corporationSelectedId,
                    isCustomer,
                    isOpenFromChatAI,
                    setOrganizationProject
                )

                if (!Utils.isEmptyObject(organizationRes)) {
                    if (!isOpenFromChatAI) {
                        if (organizationRes.value === Constant.KNOWLEDGE_VIEW_OPTION.ALL_KNOWLEDGE_IN_ORG) {
                            setTriggerSearch(Date.now().toString());
                            setDestinationPrjId('');
                        } else if (organizationRes.value === Constant.KNOWLEDGE_VIEW_OPTION.PRJ_IN_USE) {
                            setDestinationPrjId(projectInuseDetail.id);
                        } else {
                            setDestinationPrjId(organizationRes.value || '');
                        }
                    } else {
                        const propsKnowledgeInfoChatAI = props.knowledgeInfoChatAi;
                        const ticketCreatedProjectId = propsKnowledgeInfoChatAI.ticketCreatedProjectId;
                        setDestinationPrjId(ticketCreatedProjectId);
                    }
                }
                setIsInitData(false);
            } catch (error) {
                console.log('getInitDataOrganizationProject >>>', error)
                setIsInitData(false);
            }
        })();

        return () => {
            controller1.abort();
            clearMemoryLoadTicketList();
        }
    },[userPermissionView?.type]);

    useEffect(() => {
        const controller2 = new AbortController();
        const getListViewWhenChangeVisibility = async () => {
          if (
            organizationProject.value === Constant.KNOWLEDGE_VIEW_OPTION.PRJ_IN_USE &&
            visibilityKnowledgeAtom && !isCustomer
        ) {
            onChangeVisibilitySetting(visibilityKnowledgeAtom, argsCommon);
            await getListViews(argsCommon, projectSelectedId, visibilityKnowledgeAtom, knowledgeInfoChatAi, setIsScrollNewViews);
            setKnowledgeInfoChatAi(null);
          }
        };
      
        getListViewWhenChangeVisibility();

        return () => {
            controller2.abort();
        }
    }, [visibilityKnowledgeAtom, triggerReloadListView]);

    useEffect(() => {
        const controller3 = new AbortController();
        if (masterKnowledgeHyperLink.isReload) {
            setProjectSelectedId(masterKnowledgeHyperLink.projectSelectedId);
            setCorporationSelectedId(masterKnowledgeHyperLink.corporationSelectedId);

            setIsCustomer(masterKnowledgeHyperLink.isCustomer);
            setCustomerId(masterKnowledgeHyperLink.customerId);
            setTicketIdList(masterKnowledgeHyperLink.ticketIdItemList);
            setMasterKnowledgeHyperLinkStatus(masterKnowledgeHyperLink.masterKnowledgeHyperLink);
            setVisibilitySettingType(masterKnowledgeHyperLink.visibilitySettingType);

            // init data
            initDataOrganizationProject();
        }

        return () => {
            controller3.abort();
        }
    }, [masterKnowledgeHyperLink]);

    useEffect(() => {
        const controller4 = new AbortController();
        if (!userPermissionView || Utils.isEmptyObject(userPermissionView)) return;
        // init when has view
        initDataOrganizationProject();

        return () => {
            controller4.abort();
        }
    }, [
        // projectSelectedId,
        // corporationSelectedId,
        isCustomer,
        customerId,
        masterKnowledgeHyperLinkStatus,
        visibilitySettingType,
        userPermissionView,
        organizationProject,
    ]);

    useEffect(() => {
        const projectSetting = Utils.convertJSONDataToObject(projectInuseDetail.projectSetting);
        if(!Utils.isEmptyObject(projectSetting)) {
            let usingSynonym = projectSetting?.usingSynonym;
            if(!usingSynonym && viewStructure?.ticketProperty === Constant.TICKET_PROPERTY.SYNONYM) {
                let listViewNotIncludesSynonym = listView.filter(view => {
                    let structure = Utils.convertJSONDataToObject(view.structure);
                    return structure.ticketProperty !== Constant.TICKET_PROPERTY.SYNONYM
                });

                if(!Utils.isEmptyArray(listViewNotIncludesSynonym)) {
                    onChangeViewSelected(
                        listViewNotIncludesSynonym[0],
                        { ...argsCommon, clickTimeout, setClickTimeout },
                        corporationDetail
                    );
                }
            }
        }

    },[projectInuseDetail])

    useEffect(() => {
        /**
         * when changed view, auto set lastUserAction to VIEW_CHANGE and clear lastSearchTagSuggestKnowledge and searchTagSuggestKnowledge
         * if you changed dependency of this useEffect,move this logic to the function that change viewSelected and call setLastUserAction(LogKibanaConstant.SEARCH_ACTION.VIEW_CHANGE) and setLastSearchTagSuggestKnowledge([]) and setSearchTagSuggestKnowledge([])
         */
        if (lastUserAction !== LogKibanaConstant.SEARCH_ACTION.VIEW_CHANGE) {
            lastUserActionRef.current = LogKibanaConstant.SEARCH_ACTION.VIEW_CHANGE;
            lastSearchTagSuggestKnowledgeRef.current = [];
            setLastUserAction(LogKibanaConstant.SEARCH_ACTION.VIEW_CHANGE);
            setSearchTagSuggestKnowledge([]);
        }
        
        setIsShowEditTagField(false);
        setIsShowEditRangeMulti(false);
        setIsShowExportMenu(false)
    }, [viewSelected, visibilityKnowledgeAtom]);

    // viewSelected change
    useEffect(() => {
        const controller5 = new AbortController();
        if( !Utils.isEmptyObject(viewSelected)) {
            let newViewStructure = Utils.convertJSONDataToObject(viewSelected?.structure);
            if (newViewStructure && typeof newViewStructure === 'object') {
                getDrilldownItemDataSelected(props?.API, newViewStructure).then(drillDownDataRes => {
                    setDefaultSelectedOption(
                        !Utils.isEmptyArray(drillDownDataRes) ? drillDownDataRes : []
                    );
                });
            }
            setAtomKnowledgeViewSelected(viewSelected);
        }

        if (!Utils.isEmptyObject(viewStructure)) {
            let clonedStructure = {...viewStructure}
            // delete clonedStructure.visibility
            if (viewStructure.options.method) {
                let newOptions = {...clonedStructure.options}

                switch (viewStructure.options.method) {
                    case Constant.SETTING_SEARCH_KEYWORD.AND:
                        newOptions = Object.fromEntries(
                            Object.entries(clonedStructure.options).filter(([key, value]) =>
                                !(['method'].includes(key) ||
                                  (['isSearchSynonym', 'isIncludePdfFile', 'isIncludePdfPage', 'isIncludeAttachPdf'].includes(key) && value !== 1))
                            )
                        );

                        break;
                    case Constant.SETTING_SEARCH_KEYWORD.OR:
                        newOptions = Object.fromEntries(
                            Object.entries(clonedStructure.options).filter(([key, value]) =>
                                !((['isSearchSynonym', 'isIncludePdfFile', 'isIncludePdfPage', 'isIncludeAttachPdf'].includes(key) && value !== 1))
                            )
                        );
                        
                        break;
                    case Constant.SETTING_SEARCH_KEYWORD.SIMILAR:
                        newOptions = Object.fromEntries(
                            Object.entries(clonedStructure.options).filter(([key, value]) =>
                                !((['isIncludePdfFile', 'isIncludePdfPage', 'isIncludeAttachPdf'].includes(key) && value !== 1))
                            )
                        );

                        break;
                    default:
                        break;
                };

                clonedStructure = {
                    ...clonedStructure,
                    options: newOptions
                }
            }
            setListenOnChangeKnowledgeViewSelected(prev => ({
                ...viewSelected,
                structure: JSON.stringify({...clonedStructure})
            }));
        }

        return () => {
            controller5.abort();
        }
    }, [viewSelected, viewStructure]);

    useEffect(async () => {
        const controller6 = new AbortController();
        if (!isViewAllKnowledgeInCorporation(organizationProject) && Utils.isEmptyObject(organizationProject)) return;
        if (!isViewAllKnowledgeInCorporation(organizationProject) && Utils.isEmptyObject(viewSelected)) return;
        //check view was changed
        const existsView = listView.some(item => item.id === viewSelected.id);
        if (!isViewAllKnowledgeInCorporation(organizationProject) && !Utils.isEmptyObject(viewSelected) && existsView) {
            isViewWasChanged(viewSelected, argsCommon).then(isViewChanged => {
                if (isViewChanged) {
                    setIsOpenDialogViewChanged(true);
                    return () => {
                        controller6.abort();
                    }
                }
            });
        }

        if (viewStructure?.options?.filePdfId) {
            let ticketFilePdf = await getTicketById(props.API, viewStructure?.options?.filePdfId)

            const attachment = ticketFilePdf?.attachment;
            const structure = Utils.convertJSONDataToObject(viewSelected?.structure);
            if (
                Utils.isEmptyObject(ticketFilePdf) ||
                (ticketFilePdf?.deletedAt && structure.ticketProperty !== Constant.TICKET_PROPERTY.DELETE) ||
                !attachment[0]?.splitPdf ||
                (structure.ticketProperty === Constant.TICKET_PROPERTY.SENT &&
                    ticketFilePdf.public === Constant.TICKET_PUBLIC.DRAFT) ||
                (structure.ticketProperty === Constant.TICKET_PROPERTY.DRAFT &&
                    ticketFilePdf.public === Constant.TICKET_PUBLIC.PUBLIC) ||
                (structure.ticketProperty === Constant.TICKET_PROPERTY.DELETE &&
                    !ticketFilePdf?.deletedAt)
            ) {
                closeIconBreadCrumb();
                return () => {
                    controller6.abort();
                }
            }
           
        }

        if (!Utils.isEmptyObject(organizationProject)) {
            Promise.all([
                // get ticket knowledge list
                handleGetTicketKnowledge(),
                // get drilldown data
                handleGetDrilldownData()
            ])
        }

        return () => {
            controller6.abort();
        }
    }, [
        // organizationProject,
        // isCustomer,
        viewStructure.fields.length,
        viewStructure.statusFields?.length,
        viewStructure.tagFields?.length,
        viewStructure.privateBookmark?.length,
        viewStructure.sharedBookmark?.length,
        viewStructure.keyword,
        props.triggerReload,
        triggerSearch,
        // viewStructure.visibility,
        viewSelected.id,
        organizationProject,
        destinationPrjId,
        viewStructure.mcpServerSetting?.length,
    ]);

    // #77576: Reload commom data panel when click knowlead icon from knowlead chat
    useEffect(() => {
        if (reloadPanelId === props.panelId) {
            if (projectSelectedId !== props.projectSelectedId) {
                setProjectSelectedId(props.projectSelectedId);
            } else {
                if (listView[0]?.id !== viewSelected?.id) {
                    setViewSelected(listView[0]);
                }
            }
            setReloadPanelId('');
        }
    }, [reloadPanelId]);

    useEffect(() => {
        if (process.env.NODE_ENV !== 'development') {
            // let appDomain = process.env.REACT_APP_DOMAIN_NAME || '';
            let timeInterval = 15 * 60 * 1000;  // 15 mins
            // if (appDomain && appDomain.includes('dbdesk-test.ominext.dev')) {
            //     timeInterval = timeInterval*10;
            // }
            const reloadTicketLists = setInterval(() => setTriggerInterval(Date.now().toString()), timeInterval);
            window.reloadKnowledgeTickets = reloadTicketLists;
            return () => clearInterval(reloadTicketLists);
        }
    }, []);

    useEffect(async () => {
        const controller7 = new AbortController();
        if (triggerInterval) {
            
            const argsReloadTicket = {
                API: props?.API,
                setIsLoading,
                viewStructure,
                visibilityKnowledgeAtom,
                corporationSelectedId,
                setKeywordSearch,
                setTicketKnowledgeList,
                setPagination,
                ticketKnowledgeList: ticketKnowledgeList,
                pagination: pagination,
                userDetail: userDetail,
                setDrillDownDataSelected,
                keywordSearch,
                setOptionSearchTimeAgo,
                setOptionSearchTimeRange,
                inputKeyWordRef,
                projectSelectedId,
                projectInuseDetail,
                setTotalTickets,
                viewSelected,
                corporationDetail,
                destinationPrjId
            }
            if(viewStructure?.options?.filePdfId) {
                let ticketFilePdf = await getTicketById(props.API, viewStructure?.options?.filePdfId)
    
                const attachment = ticketFilePdf?.attachment;
                const structure = Utils.convertJSONDataToObject(viewSelected?.structure);
                if (
                    Utils.isEmptyObject(ticketFilePdf) ||
                    (ticketFilePdf?.deletedAt && structure.ticketProperty !== Constant.TICKET_PROPERTY.DELETE) ||
                    !attachment[0]?.splitPdf ||
                    (structure.ticketProperty === Constant.TICKET_PROPERTY.SENT &&
                        ticketFilePdf.public === Constant.TICKET_PUBLIC.DRAFT) ||
                    (structure.ticketProperty === Constant.TICKET_PROPERTY.DRAFT &&
                        ticketFilePdf.public === Constant.TICKET_PUBLIC.PUBLIC) ||
                    (structure.ticketProperty === Constant.TICKET_PROPERTY.DELETE &&
                        !ticketFilePdf?.deletedAt)
                ) {
                    closeIconBreadCrumb();
                    return () => {
                        controller7.abort();
                    }
                }
               
            }
            autoReloadTicket(argsReloadTicket);
            handleGetDrilldownData();
        }

        return () => {
            controller7.abort();
        }
    }, [triggerInterval]);

    useEffect(() => {
        const controller8 = new AbortController();
        (async () => {
            if (!organizationProject || Utils.isEmptyObject(organizationProject)) return;
            let isShowIconChatAI = await isDisplayIconChatAIOnKnowledgeList(
                props?.API,
                userPermissionView,
                corporationDetail,
                projectInuseDetail,
                organizationProject
            )
            setIsDisplayIconChatAI(Boolean(isShowIconChatAI));
        })();

        return () => {
            controller8.abort();
        }
    },[organizationProject, projectInuseDetail])

    // handle display bookmark
    useEffect(() => {
        let ticketProperty = Constant.TICKET_PROPERTY.SENT;
        const structure = Utils.convertJSONDataToObject(viewSelected?.structure);
        if (!Utils.isEmptyObject(structure)) {
            ticketProperty = structure?.ticketProperty;
        }

        const isDeleteView = ticketProperty === Constant.TICKET_PROPERTY.DELETE
        setIsViewDelete(isDeleteView)
        

    }, [organizationProject, viewSelected])
    
    useEffect(() => {
        const controller9 = new AbortController();
        (async () => {
            const chatbotCategories = await getCategoryListOfProject(
                props?.API,
                projectInuseDetail?.id
            );
            if (!Utils.isEmptyArray(chatbotCategories)) setChatbotCategories(chatbotCategories);
        })();

        return () => {
            controller9.abort();
        };
    }, [projectInuseDetail]);

    const handleGetTicketKnowledge = (paginationFrom = 0, paginationSize = 20) => {
        setIsLoading(true);
        
        getListTicketKnowledge(
            argsCommon, 
            paginationFrom, 
            paginationSize, 
            lastUserActionRef.current, 
            corporationDetail, 
            projectInuseDetail, 
            userDetail, 
            searchContentType, 
            lastSearchTagSuggestKnowledgeRef.current,
            removedTagItem, 
            setRemovedTagItem
        );
    };

    const handleGetDrilldownData = async () => {
        setIsLoadingDrillDown(true);

        let ticketProperty = viewStructure.ticketProperty;
        if (!ticketProperty && !Utils.isEmptyObject(viewSelected)) {
            let viewSelectedStructure = Utils.convertJSONDataToObject(viewSelected.structure);
            ticketProperty = viewSelectedStructure?.ticketProperty;
        }

        if (!ticketProperty) {
            ticketProperty = Constant.TICKET_PROPERTY.SENT;
        }
        let visibility = viewStructure.visibility
            ? viewStructure.visibility
            : visibilityKnowledgeAtom;
        
            if (corporationSelectedId !== corporationDetail?.id || Utils.isB2CUser(userDetail)) {
                visibility = Constant.VISIBILITY_SETTING_TYPE.CUSTOMER;
            }

        let filterParams = {
            corporationId: corporationSelectedId ? corporationSelectedId : localStorageUtil.getAffiliationOrganization(),
            projectId: projectSelectedId,
            userId: localStorageUtil.getUserDetailId(),
            isCustomer: isCustomer,
            visibility: visibility,
            viewStructure: {
                ...viewStructure,
                ticketCreatedProjectId: destinationPrjId
            },
            ticketProperty: ticketProperty,
            from: 0,
            size: 2000,
            projectInuse: projectInuseDetail?.id || localStorageUtil.getSelectedProjectId(),
            userAffiliationOrganization: corporationDetail?.id || localStorageUtil.getAffiliationOrganization(),
            projectInuseType: projectInuseDetail?.type || localStorageUtil.getSelectedProjectType(),
        };
        
        // 1. query drilldown list
        const drillDownDataResult = await getCurrentDrilldownData(argsCommon, filterParams, false, setCurrentSearchParams);
        setDrillDownData(drillDownDataResult?.drillDownData);
        setSugguestionList(drillDownDataResult?.sugguestionList);
        
        let rawDrilldownData = drillDownDataResult.rawDrilldownData;
        if(rawDrilldownData?.hasOwnProperty('affiliationProjects') && rawDrilldownData['affiliationProjects']?.hideInProject){
            setIsDisplayDestinationPrjBreadCrumbState(false)
        }else{
            setIsDisplayDestinationPrjBreadCrumbState(true)
        }
        
        // https://new.redmine.ominext.com/issues/205267
        setIsLoadingDrillDown(false);

        // 2. query drilldown default
        setIsLoadingDefaultDrilldown(true);

        let defaultViewStructure = cloneDeep(Constant.DEFAULT_VIEW_STRUCTURE);
        defaultViewStructure.visibility = visibility;
        defaultViewStructure.ticketCreatedProjectId = viewStructure.ticketCreatedProjectId;
        let defaultFilterParams = { ...filterParams, viewStructure: defaultViewStructure };
        
        const resDefaultDrillDownData = await getCurrentDrilldownData(argsCommon, defaultFilterParams, true);
        setDefaultDrillDownData(resDefaultDrillDownData?.drillDownData);
        
        setIsLoadingDefaultDrilldown(false);
        
        // 3. query getDataPublicRange
        getDataPublicRange(argsCommon, filterParams)
    };

    const getNextPage = () => {
        const paginationClone = { ...pagination };
        paginationClone.from = paginationClone.from + 20;
        handleGetTicketKnowledge(paginationClone.from, paginationClone.size);
    };


    const onClickAddNewView = async () => {
        let defaultVisibility = visibilityKnowledgeAtom;

        // Fix for https://new.redmine.ominext.com/issues/222170
        // When search by page unit, change viewStructure => viewStructure.visibility is not correct.
        if (viewStructure?.options?.filePdfId && viewStructure?.options?.getListPdfPage && previousViewStructure?.visibility) {
            defaultVisibility = previousViewStructure?.visibility;
        }

        if(defaultVisibility === Constant.VISIBILITY_SETTING_TYPE.PROJECT) {
            defaultVisibility = Constant.VISIBILITY_SETTING_TYPE.PRIVATE;
        }

        setIsLoading(true);
        setAddViewPopover(null);
        createNewView(argsCommon, defaultVisibility).then(() => {
            setIsLoading(false);
            let nodeListViews = document.querySelectorAll('.item-knowledge');
            let containerRect = element.getBoundingClientRect();
            let posElem = [];
            for (let i = 0; i < nodeListViews.length; i++) {
                let visiblePageWidth = getVisibleWidth(nodeListViews[i]);
                posElem.push({ pos: visiblePageWidth });
            }
            element.scrollLeft +=
                posElem[posElem.length - 1].pos.width -
                (containerRect.width - posElem[posElem.length - 1].pos.left);
        });
    };

    const handleClickOpenListViewHide = () => {
        let listViewHide = listView.filter(view => view.status === Constant.STATUS_VIEW.HIDDEN);
        if (!Utils.isEmptyArray(listViewHide)) {
            setOpenListViewHide(!openListViewHide);
        } else {
            setOpenListViewHide(false);
        }
    };

    const openChatThreadPanel = async (ticketDetail) => {
        ticketDetail = await getTicketById(props?.API, ticketDetail.id);

        if (userDetail?.id !== ticketDetail?.creator) {
            setIsLoading(true);
            let isValid = await hasKnowledgeChatPermissionInChatThread(
                ticketDetail,
                projectInuseDetail,
                userDetail?.id,
                false
            );
            setIsLoading(false);
            if (!isValid) {
                setIsOpenModalReloadPage(true);
                return;
            }
        }
        addNewPanel({
            //update
            type: Constant.PANEL_TYPE.KNOWLEDGE_CHATTHREAD,
            tabId: ticketDetail.id,
            props,
            ticketId: ticketDetail.id,
            ticketOutline: ticketDetail.outline,
            isTicketDeleted: !Utils.isEmptyString(ticketDetail?.deletedAt) ? true : false
        });

        const newTicketList = ticketKnowledgeList.map(ticket => {
            if (ticket?.id === ticketDetail?.id) {
                return { ...ticket, totalUnreadMsg: 0 };
            }
            return ticket;
        });
        setTicketKnowledgeList(newTicketList);
    };

    const handleOpenFile = (event, fileUploadInfor, ticketDetail, isPdfFile = false) => {
        let item = {
            content: fileUploadInfor.fileName,
            fileSize: parseInt(fileUploadInfor.fileSize),
            fileUrl: fileUploadInfor.fileUrl,
            type: 1
        };
        downloadFileFromS3(item, ticketDetail,false,isPdfFile, '', setIsShowPopupLogout);
    };

    const renderTicketKnowledgeItem = ticketKnowledge => {
        if (!ticketKnowledge) return null
        return (
            <ListKnowledgeItem
                key={ticketKnowledge.id}
                corporationDetail={corporationDetail}
                isViewDelete={isViewDelete}
                projectInuseDetail={projectInuseDetail}
                openChatThreadPanel={openChatThreadPanel}
                userPermissionView={userPermissionView}
                addViewPopover={addViewPopover}
                setFootPrintPopover={setFootPrintPopover}
                ticketKnowledgeList={ticketKnowledgeList}
                setUserFootprintList={setUserFootprintList}
                idPopOverFootPrint={idPopOverFootPrint}
                openPopoverFootPrint={openPopoverFootPrint}
                footPrintPopover={footPrintPopover}
                userFootprintList={userFootprintList}
                argsCommon={argsCommon}
                addNewPanel={addNewPanel}
                setLastUserAction={setLastUserAction}
                userDetail={userDetail}
                isProjectManager={isProjectManager}
                viewStructure={viewStructure}
                idPopoverShareStatus={idPopoverShareStatus}
                setShareStatusPopover={setShareStatusPopover}
                setOpenShareStatusPopover={setOpenShareStatusPopover}
                openShareStatusPopover={openShareStatusPopover}
                shareStatusPopover={shareStatusPopover}
                shareStatusData={shareStatusData}
                isShowIconPageUnit={isShowIconPageUnit}
                setPreviousViewStructure={setPreviousViewStructure}
                setViewStructure={setViewStructure}
                isCustomer={isCustomer}
                setFileNamePdfSelect={setFileNamePdfSelect}
                setTriggerSearch={setTriggerSearch}
                fileNamePdfSelect={fileNamePdfSelect}
                corporationSelectedId={corporationSelectedId}
                setIsOpenModalReloadPage={setIsOpenModalReloadPage}
                setIsLoading={setIsLoading}
                handleOpenFile={handleOpenFile}
                visibilityKnowledgeAtom={visibilityKnowledgeAtom}
                ticketKnowledge={ticketKnowledge}
                setIsShowPopupLogout={setIsShowPopupLogout}
                setOpenPreviewImage={setOpenPreviewImage}
            />
        );
    };

    const handleOnScroll = event => {
        let elementWhenScroll = event.target;
        if (
            elementWhenScroll.offsetHeight + elementWhenScroll.scrollTop >= elementWhenScroll.scrollHeight &&
            pagination.lastTotal === 20
        ) {
            getNextPage();
        }
    };

    const isShowOptionSearchSimilar = () => {
        if(viewStructure.ticketProperty === Constant.TICKET_PROPERTY.SYNONYM) {
            return false;
        }

        let isNotSearchChat = viewStructure.options.attribute !== Constant.SETTING_SEARCH_KEYWORD.COMMENT
        
        let usingChatAI = corporationDetail.limitValue?.usingChatAI === Constant.STATUS_SERVICE_PERMISSION.ON ? true : false;
        if ([Constant.CORPORATION_CONTRACT_TYPE.GUEST, Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK].includes(corporationDetail.contractType)) {
            usingChatAI = corporationDetail.inviterUsingChatAI === Constant.STATUS_SERVICE_PERMISSION.ON;
        }
        //TODO: Temporarily comment here and set its value to true
        let AIVectorizationCompleted = true
        return (usingChatAI && AIVectorizationCompleted && isNotSearchChat);
    }

    useEffect(() => {
        let isReloadData = false;
        if (!Utils.isEmptyObject(viewSelected)) {
            let viewSelectedStructure = Utils.convertJSONDataToObject(viewSelected.structure);
            let viewSelectedOptions = viewSelectedStructure.options;
            isReloadData = corporationDetail.limitValue?.usingChatAI === Constant.STATUS_SERVICE_PERMISSION.ON && viewSelectedOptions.method === Constant.SETTING_SEARCH_KEYWORD.SIMILAR;
            if (isReloadData) {
                setViewStructure(viewSelectedStructure);
            }
        }
        if (corporationDetail.limitValue?.usingChatAI === Constant.STATUS_SERVICE_PERMISSION.OFF && isCheckMethodSimilar(viewStructure)) {
            isReloadData = true;
            let newViewStructure = cloneDeep(viewStructure);
            newViewStructure.options['sort'] = optionsSort !== Constant.DRILLDOWN_SEARCH_OPTION_SORT_TYPE.SIMILAR ? optionsSort : Constant.DRILLDOWN_SEARCH_OPTION_SORT_TYPE.UPDATED_AT;
            newViewStructure.options.method = Constant.SETTING_SEARCH_KEYWORD.AND;
            setViewStructure(newViewStructure);
        }
        if (isReloadData) {
            setTriggerSearch(Date.now().toString());
        }

    }, [corporationDetail.limitValue?.usingChatAI]);

    const [openingTabChatAi, setOpeningTabChatAi] = useState('');

    // uef open tab ChatAI
    useEffect(() => {
        if (Utils.isEmptyString(openingTabChatAi) || Utils.isEmptyArray(panelList)) return;
        const panelOpenChatAi = panelList.find(p => p.type === Constant.PANEL_TYPE.OPEN_CHAT_AI);
        
        if (!panelOpenChatAi?.isDisplay) return;

        const listTabChatAi = panelOpenChatAi.tabList;
        const isOpened = listTabChatAi.find(t => t.id === openingTabChatAi);

        let createTimeout;
        if (isOpened) {
            createTimeout = setTimeout(() => {
                setOpeningTabChatAi('');
                hideLoadingMouse();
            }, 3000);
        }

        return () => {
            if (createTimeout) {
                clearTimeout(createTimeout);
            }
        }

    }, [openingTabChatAi, panelList])

    const onClickOpenChatAIPanel = async () => {
        showLoadingMouse();
        if (!Utils.isEmptyString(openingTabChatAi)) return;

        const propsClone = cloneDeep(props);
       
        let currentPanelId = propsClone.panelId;
        delete propsClone.setPanelList;
        delete propsClone.setSettingSlide;
        delete propsClone.setSettingSlideRecoilState;
        delete propsClone.setPanelListRecoilState
        delete propsClone.panelListRecoilState;
        delete propsClone.onStateChange;
        delete propsClone.history;
        delete propsClone.computedMatch;
        delete propsClone.corporationDetail;
        delete propsClone.projectDetail;
        delete propsClone.userDetail;

        let projectIdKnowledgeSelected = organizationProject.value;
        if (organizationProject.value === Constant.KNOWLEDGE_VIEW_OPTION.PRJ_IN_USE) {
            projectIdKnowledgeSelected = projectInuseDetail.id;
        }

        const viewStructureClone = cloneDeep(viewStructure);
        viewStructureClone.visibility = viewStructureClone.visibility
            ? viewStructureClone.visibility
            : visibilityKnowledgeAtom;

        const newThreadId = `ai_chat_thread_${uuidv4()}`;
        const filterKnowledgeListData = {
            viewStructure: viewStructureClone,
            projectSelectedId: projectIdKnowledgeSelected,
            resetSearchCondition: false,
            usingBasicPrompt: true,
            isInvalidPrecondition: false,
            threadId: newThreadId,
            chatThreadId: newThreadId,
            viewSelected: viewSelected,
            viewSelectedId: viewSelected?.id,
            projectIdKnowledgeSelected: projectIdKnowledgeSelected,
            isShowVisibilityKnowledgeAtom: isShowVisibilityKnowledgeAtom,
            visibilityKnowledgeAtom: visibilityKnowledgeAtom,
            hitNumber: totalTickets,
            ticketCreatedProjectId: destinationPrjId || projectIdKnowledgeSelected,
            ticketCreatedCorporationId: corporationSelectedId,
        }

        const panelDataChatAI = panelList?.find(
            panel => panel?.type === Constant.PANEL_TYPE.OPEN_CHAT_AI
        );
        const isLimited = await isLimitedTabsLength({
            panelDataChatAI,
            projectInuseDetail,
            userDetail
        });
        if (isLimited) {
            enqueueSnackbar(buildSnackbarMessage('MSG-CM-WARNING-LIMIT-TAB'), {
                variant: 'error',
                autoHideDuration: 3000,
                style: { whiteSpace: 'pre-line' }
            });
            const tabList = panelDataChatAI?.tabList || [];
            if (!Utils.isEmptyArray(tabList) && !panelDataChatAI?.isDisplay) {
                const lastTab = tabList[tabList.length - 1];
                addNewPanel({
                    type: Constant.PANEL_TYPE.OPEN_CHAT_AI,
                    tabId: lastTab.id,
                    filterKnowledgeListData: {
                        ...filterKnowledgeListData,
                        threadId: lastTab.chatThreadId,
                        chatThreadId: lastTab.chatThreadId
                    },
                    chatThreadId: lastTab.chatThreadId,
                    currentPanelId: currentPanelId,
                    props: {
                        ...propsClone,
                        projectSelectedId: projectIdKnowledgeSelected,
                        visibilitySettingType: visibilityKnowledgeAtom,
                    }
                });
                setOpeningTabChatAi(lastTab.id);
            }
            hideLoadingMouse();
        } else {
            const chatThreadDto = {
                id: newThreadId,
                chatThreadId: newThreadId,
                corporationId: corporationDetail.id,
                affiliationProject: projectIdKnowledgeSelected,
                clientUUId: `client_uuid_${uuidv4()}`,
                creatorId: userDetail.id,
                metaData: { filterKnowledgeListData: JSON.stringify(filterKnowledgeListData) }
            }
            let tabId = `${Constant.TAB_PANEL_TYPE.NEW_TAB_CHAT_AI}_${Date.now().toString()}`;
    
            const newThreadChat = await createNewAIChatThread(chatThreadDto);
            if(!Utils.isEmptyObject(newThreadChat)) {
                addNewPanel({
                    type: Constant.PANEL_TYPE.OPEN_CHAT_AI,
                    tabId: tabId,
                    filterKnowledgeListData: filterKnowledgeListData,
                    chatThreadId: newThreadId,
                    currentPanelId: currentPanelId,
                    props: {
                        ...propsClone,
                        
                        projectSelectedId: projectIdKnowledgeSelected,
                        visibilitySettingType: visibilityKnowledgeAtom,
                    }
                });
                setOpeningTabChatAi(tabId);
            }
        }
    }

    const isShowIconPageUnit = (ticketKnowledge, file) => {
        try {
            if (!ticketKnowledge || !file) return false;
            
            if (
                [Constant.TICKET_TYPE.KNOWLEDGE, Constant.TICKET_TYPE.MASTER_KNOWLEDGE].includes(
                    ticketKnowledge.ticketType
                ) &&
                !file?.idTicketFileKnowledge
            )
                return false;
            const displayTextInFile = displayTagOfThumbAttach(ticketKnowledge, file.fileName);

            const isDisplayPdf = displayTextInFile.name === 'pdf';
            return (
                isDisplayPdf &&
                file.splitPdf &&
                !file.isCreatingPageKnowledge &&
                viewStructure?.ticketProperty !== Constant.TICKET_PROPERTY.SYNONYM &&
                ticketKnowledge?.ticketType !== Constant.TICKET_TYPE.PDF_PAGE_KNOWLEDGE &&
                checkIsEnablePdfFunction()
            );
        } catch (error) {}
    };

    const isShowAddNewView = () => {
        if (
            [
                Constant.TICKET_PROPERTY.DRAFT,
                Constant.TICKET_PROPERTY.DELETE,
                Constant.TICKET_PROPERTY.SYNONYM
            ].includes(viewStructure?.ticketProperty)
        )
            return false;

        return true;
    };

    const isDisplayIconCloseDestinationPrj = () => {
        const ticketProperty = viewStructure?.ticketProperty || Constant.TICKET_PROPERTY.SENT;
        return ![
            Constant.TICKET_PROPERTY.DRAFT,
            Constant.TICKET_PROPERTY.DELETE,
            Constant.TICKET_PROPERTY.SYNONYM
        ].includes(ticketProperty)
    }

    const isDisplayDestinationPrjBreadCrumb = () => {
        return (
            !Utils.isEmptyObject(organizationProject) &&
            !Utils.isEmptyString(destinationPrjId) && isDisplayDestinationPrjBreadCrumbState
        )
    }

    const getDestinationPrjName = (prjId) => {
        if (Utils.isEmptyString(prjId)) return '';

        if (prjId === projectInuseDetail.id) {
            return trI18n('CM-LABEL-PRJ-IN-USE');
        }
        let listProject = [
            ...organizationProject?.internalProjectList,
            ...organizationProject?.externalProjectList
        ];
        
        const selectedPrj = listProject.find(prj => prj.id === prjId);
        if (selectedPrj) return selectedPrj.label;

        return '';
    }

    const renderContentTab = () => {
        return (
            <div className="content-tab-body">
                {/* Search Input */}
                <div className="searchFrame">
                    <div className="searchFrame-wrap">
                        <div className="searchFrame-actions">
                            <Select
                                disabled={
                                    viewStructure.options.method ==
                                    Constant.SETTING_SEARCH_KEYWORD.SIMILAR
                                }
                                className="search-options-select"
                                variant="outlined"
                                defaultValue={Constant.SETTING_SEARCH_KEYWORD.MUTIPLE}
                                value={
                                    viewStructure.options.attribute
                                        ? viewStructure.options.attribute
                                        : Constant.SETTING_SEARCH_KEYWORD.MUTIPLE
                                }
                                onChange={e => handleChangeSearchAttribute(e, argsCommon)}
                                MenuProps={{
                                    anchorOrigin: {
                                        vertical: 'bottom',
                                        horizontal: 'left'
                                    },
                                    transformOrigin: {
                                        vertical: 'top',
                                        horizontal: 'left'
                                    },
                                    getContentAnchorEl: null,
                                    className: 'selectDrop'
                                }}
                            >
                                <MenuItem value={Constant.SETTING_SEARCH_KEYWORD.MUTIPLE}>
                                    {trI18n('DRILLB012')}
                                </MenuItem>
                                <MenuItem value={Constant.SETTING_SEARCH_KEYWORD.COMMENT}>
                                    {trI18n('DRILLB013')}
                                </MenuItem>
                            </Select>
                            
                            {/* Input Search */}
                            <SearchInput
                                argsCommon={argsCommon}
                                drillDownData={drillDownData}
                                viewStructure={viewStructure}
                                inputKeyWordRef={inputKeyWordRef}
                                keywordSearch={keywordSearch}
                                setKeywordSearch={setKeywordSearch}
                                suggestionList={sugguestionList}
                            />
                        </div>
                        <Button
                            className="btn-tag-search btn-light btn-hg32 btn-open-drilldown"
                            variant="outlined"
                            onClick={e => openDrilldownAndDetailSearch(argsCommon)}
                            startIcon={
                                <span className="itemSearch">
                                    <img src="/assets/image/icon-btnSearch.svg" alt="" />
                                </span>
                            }
                        >
                            {trI18n('CM-BUTTON-OPEN-DRILLDOWN')}
                        </Button>
                        {isDisplayIconChatAI && (
                            <Tooltip
                                placement="bottom-start"
                                arrow={true}
                                title={trI18n(
                                    'MSG-AI-TOOLTIP-WHEN-OPEN-AI-ON-KNOLEDGE-LIST-PANEL'
                                )}
                            >
                                <img
                                    src="/assets/image/icon-chat-ai.svg"
                                    alt="chat-ai-icon"
                                    className="chat-ai-btn"
                                    onClick={async () => await onClickOpenChatAIPanel()}
                                />
                            </Tooltip>
                        )}
                    </div>
                </div>

                <div className="search-options-group">
                    <div className="search-option-method-attribute content-padding">
                        <RadioGroup
                            id="radio-buttons-group-search-method"
                            key={`row-radio-buttons-group-search-method`}
                            row
                            aria-labelledby="radio-buttons-group-label-method"
                            name="row-radio-buttons-group-search-method"
                            value={
                                viewStructure.options.method
                                    ? viewStructure.options.method
                                    : Constant.SETTING_SEARCH_KEYWORD.AND
                            }
                            onChange={e => handleChangeSearchMethod(e, argsCommon)}
                        >
                            <div className="searchOption-radio">
                                <FormControlLabel
                                    className="custom-radio search-item"
                                    value={Constant.SETTING_SEARCH_KEYWORD.AND}
                                    control={<Radio size="small" />}
                                    label={trI18n('DRILLB010')}
                                />
                                <FormControlLabel
                                    className="custom-radio search-item"
                                    value={Constant.SETTING_SEARCH_KEYWORD.OR}
                                    control={<Radio size="small" />}
                                    label={trI18n('DRILLB011')}
                                />
                                {isShowOptionSearchSimilar() && (
                                    <FormControlLabel
                                        className="custom-radio search-item"
                                        value={Constant.SETTING_SEARCH_KEYWORD.SIMILAR}
                                        control={<Radio size="small" />}
                                        label={trI18n('OPTION-SEARCH-SIMILAR')}
                                        disabled={isDisableSimilarSearch}
                                    />
                                )}
                            </div>
                        </RadioGroup>
                    </div>

                    {isDisplayIconSearchFileAndPageKnowledge(
                        corporationDetail,
                        viewStructure,
                        Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST
                    ) && (
                        <Tooltip
                            arrow={true}
                            title={trI18n('MSG-SEARCH-INCLUDES-PDF-OF-KNOWLEDGE')}
                        >
                            <div className="checkbox-search-includes-page-pdf">
                                <div className="search-item">
                                    <input
                                        type="checkbox"
                                        id={`checkbox-include-attach-pdf`}
                                        checked={isIncludeAttachPdf}
                                        className="search-include-attach-pdf"
                                        onChange={e => {
                                            setIsIncludeAttachPdf(e.target.checked);
                                            handleChangeSearchPdfOption(
                                                e.target.checked,
                                                'isIncludeAttachPdf',
                                                {
                                                    viewStructure,
                                                    setViewStructure
                                                }
                                            );
                                        }}
                                        disabled={isDisableIncludeAttachPdf}
                                    />
                                    <label
                                        className={`label-search-pdf ${
                                            isDisableIncludeAttachPdf
                                                ? 'search-synonym-disable'
                                                : 'search-synonym-enable'
                                        }`}
                                        htmlFor={`checkbox-include-attach-pdf`}
                                    >
                                        {trI18n('LABEL_INCLUDE_ATTACH_PDF')}
                                    </label>
                                </div>
                            </div>
                        </Tooltip>
                    )}

                    {isDisplayOptionSearchSynonymForKnowledgeList(
                        corporationDetail,
                        projectInuseDetail,
                        organizationProject,
                        viewStructure
                    ) && (
                        <Tooltip
                            arrow={true}
                            title={
                                organizationProject.value ===
                                Constant.KNOWLEDGE_VIEW_OPTION.ALL_KNOWLEDGE_IN_ORG
                                    ? trI18n('MSG-CM-USE-CURRENT-SYNONYM-KNOW-TO-SEARCH')
                                    : trI18n('MSG-CM-USE-SYNONYM-KNOW-TO-SEARCH')
                            }
                        >
                            <div className="search-synonym-option search-item">
                                <input
                                    type="checkbox"
                                    id={`checkbox-include-search-synonym`}
                                    checked={isSearchSynonym}
                                    className="search-synonym-checkbox"
                                    onChange={e => {
                                        setIsSearchSynonym(e.target.checked);
                                        handleOnChangeSearchSynonym(
                                            e.target.checked,
                                            'isSearchSynonym',
                                            {
                                                viewStructure,
                                                setViewStructure,
                                                ...argsCommon
                                            }
                                        );
                                    }}
                                    disabled={isDisableSynonymSearch}
                                />
                                <label
                                    className={`label-search-synonym ${
                                        isDisableSynonymSearch
                                            ? 'search-synonym-disable'
                                            : 'search-synonym-enable'
                                    }`}
                                    htmlFor={`checkbox-include-search-synonym`}
                                >
                                    {tr('類義語展開する')}
                                </label>
                            </div>
                        </Tooltip>
                    )}
                </div>

                {isShowIconBreadCrumb() && (
                    <div className="searchCondition searchCondition-page-knowledge">
                        <div className="searchCondition-item" key="breadcrumb">
                            <span className="close-icon">
                                <CloseIcon
                                    fontSize="inherit"
                                    onClick={() => closeIconBreadCrumb()}
                                />
                            </span>
                            <span className="option-name">
                                {trI18n('LABEL-PAGE-KNOWLEDGE-UNIT')}
                                {fileNamePdfSelect ? `(${fileNamePdfSelect})` : ''}
                            </span>
                        </div>
                    </div>
                )}

                <div className="searchCondition">
                    {!Utils.isEmptyArray(drilldownDataSelected) &&
                        drilldownDataSelected
                            ?.filter(item => {
                                
                                // filter bookmark of other project
                                if(item.id === Constant.FORMAT_OPTION_SEARCH.SHARED_BOOKMARK){
                                    let sharedBookmarkOfView = viewStructure.sharedBookmark;
                                    if(!Utils.isEmptyArray(sharedBookmarkOfView)){
                                        const bookmarkItem = sharedBookmarkOfView?.find(bookmark => bookmark.bookmarkId === item.itemId);
                                        if(!Utils.isEmptyObject(bookmarkItem) && bookmarkItem.projectSelectId !== projectInuseDetail.id ){
                                            return false
                                        }
                                    }
                                };

                                // filter private bookmark
                                if(item.id === Constant.FORMAT_OPTION_SEARCH.PRIVATE_BOOKMARK){
                                    let privateBookmarkOfView = viewStructure.privateBookmark;
                                    if(!Utils.isEmptyArray(privateBookmarkOfView)){
                                        const bookmarkItem = privateBookmarkOfView?.find(bookmark => bookmark.bookmarkId === item.itemId);
                                        if (
                                            !Utils.isEmptyObject(bookmarkItem) &&
                                            (bookmarkItem.projectSelectId !==
                                                projectInuseDetail.id ||
                                                bookmarkItem.userSelectId !== userDetail.id)
                                        ) {
                                            return false;
                                        }
                                    }
                                };
                                if (item.isPdfSystemFile && !checkIsEnablePdfFunction()) {
                                    return false;
                                }

                                return item.isDisplay

                            })
                            ?.map(item => {
                                const displayItemLabel = getSelectedDrilldownItemDisplayLabel(item);
                                const displayFieldLabel = getSelectedDrilldownFieldDisplayLabel(item);

                                return (
                                    <div
                                        className="searchCondition-item"
                                        key={`${item.id}${item.itemLabel}`}
                                    >
                                        <span className="close-icon">
                                            {item.fieldLabel !==
                                                trI18n('CM-DROPDOWN-PRJ-CREATE-KNOWLEDGE') && (
                                                <CloseIcon
                                                    fontSize="inherit"
                                                    onClick={e =>
                                                        removeDrillDownSelected(
                                                            item,
                                                            argsCommon,
                                                            setIsShowEditTagField
                                                        )
                                                    }
                                                />
                                            )}
                                        </span>
                                        <Tooltip
                                            title={displayItemLabel}
                                            arrow={false}
                                            placement="top-start"
                                        >
                                            <span className="itemTagFieldLabel">
                                                {displayItemLabel}
                                            </span>
                                        </Tooltip>
                                        <span className="option-name">←</span>
                                        <span className="option-name">{displayFieldLabel}</span>
                                    </div>
                                );
                            })}
                    
                    {isDisplayDestinationPrjBreadCrumb() && (
                        <div className="searchCondition-item" key="destinationPrjBreadcrumb">
                            <span className="close-icon">
                                {isDisplayIconCloseDestinationPrj() && (
                                    <CloseIcon
                                        fontSize="inherit" 
                                        onClick={e => {
                                            setIsShowEditRangeMulti(false)
                                            setIsShowEditTagField(false)

                                            removeDrillDownSelected(
                                                {
                                                    id:
                                                        Constant.FORMAT_OPTION_SEARCH
                                                            .TICKET_CREATED_PROJECT_ID,
                                                    value: destinationPrjId,
                                                    itemLabel: getDestinationPrjName(
                                                        destinationPrjId
                                                    ),
                                                    fieldLabel: trI18n(
                                                        'CM-DROPDOWN-PRJ-CREATE-KNOWLEDGE'
                                                    )
                                                },
                                                argsCommon,
                                                setIsShowEditTagField
                                            );
                                        }}
                                    />
                                )}
                            </span>
                            <span className="option-name">
                                {getDestinationPrjName(destinationPrjId)}←
                                {trI18n('CM-DROPDOWN-PRJ-CREATE-KNOWLEDGE')}
                            </span>
                        </div>
                    )}

                    {optionSearchTimeRange && (
                        <div className="searchCondition-item" key="optionSearchTimeRange">
                            <span className="close-icon">
                                <CloseIcon
                                    fontSize="inherit"
                                    onClick={e =>
                                        removeDrillDownSelectedSearchTimeRange(argsCommon)
                                    }
                                />
                            </span>
                            <span>{optionSearchTimeRange}</span>
                        </div>
                    )}

                    {optionSearchTimeAgo && (
                        <div className="searchCondition-item" key="optionSearchTimeAgo">
                            <span className="close-icon">
                                <CloseIcon
                                    fontSize="inherit"
                                    onClick={e => removeDrillDownSelectedSearchTimeAgo(argsCommon)}
                                />
                            </span>
                            <span>{optionSearchTimeAgo}</span>
                        </div>
                    )}
                </div>

                {/* BulkAction */}
                <BulkAction
                    listTicketKnowledge={ticketKnowledgeList}
                    totalTickets={totalTickets}
                    viewSelected={viewSelected}
                    selectedProject={organizationProject.value}
                    onSubmitSearchListKnowledge={() => onSubmitSearchListKnowledge(argsCommon)}
                    currentSearchParams={currentSearchParams}
                    // isHasEditPermissionEveryTicket={isHasEditPermissionEveryTicket}
                    isHasEditPermissionSomeTicket={isHasEditPermissionSomeTicket}
                    viewStructure={viewStructure}
                    drillDownData={drillDownData}
                    isProjectManager={isProjectManager}
                    projectInuseDetail={projectInuseDetail}
                    setIsShowEditRangeMulti={setIsShowEditRangeMulti}
                    setIsShowEditTagField={setIsShowEditTagField}
                    setIsShowDialogNotiLimit={setIsShowDialogNotiLimit}
                    msgInProcessingIcon={msgInProcessingIcon}
                    setMsgInProcessingIcon={setMsgInProcessingIcon}
                    setLimitNotiMessage={setLimitNotiMessage}
                    corporationDetail={corporationDetail}
                    selectedFilterForm={selectedFilterForm}
                    setSelectedFilterForm={setSelectedFilterForm}
                    setIsShowExportMenu={setIsShowExportMenu}
                    isOpenDialogConfirm = {isOpenDialogConfirm}
                    setIsOpenDialogConfirm={setIsOpenDialogConfirm}
                    formIdSearchConditionFilterBy={formIdSearchConditionFilterBy}
                />
                {isShowFormEditRangeMulti(
                    projectList,
                    destinationPrjId,
                    totalTickets, 
                    isShowEditRangeMulti, 
                    organizationProject.value)  && (
                    <RenderMultiPublicRange 
                        listAdditionalAllRole={listAdditionalAllRole}
                        currentSearchParams={currentSearchParams}
                        listDataPublicRange={listDataPublicRange}
                        totalTickets={totalTickets}
                        setIsShowEditRangeMulti={setIsShowEditRangeMulti}
                        setListAdditionalAllRole={setListAdditionalAllRole}
                        setListDataPublicRange={setListDataPublicRange}
                        isLoadDataForPublicRangeDone={isLoadDataForPublicRangeDone}
                        setIsShowDialogNotiLimit={setIsShowDialogNotiLimit}
                        msgInProcessingIcon={msgInProcessingIcon}
                        setMsgInProcessingIcon={setMsgInProcessingIcon}
                        drilldownDataSelected={drilldownDataSelected}
                    />
                )}
                {isShowEditTagFields && (
                    <RenderTagFieldInForm
                        setIsShowEditTagField={setIsShowEditTagField}
                        listTagFieldOfForm={listTagFieldOfForm}
                        drillDownData={drillDownData}
                        totalTickets={totalTickets}
                        currentSearchParams={currentSearchParams}
                        setIsShowDialogReload = {setIsShowDialogReload}
                        setIsShowDialogNotiLimit={setIsShowDialogNotiLimit}
                        msgInProcessingIcon={msgInProcessingIcon}
                        setMsgInProcessingIcon={setMsgInProcessingIcon}
                        loadingBulkItemListTagField={loadingBulkItemListTagField}
                        action={Constant.BULK_ACTION.EDIT_TAG_FIELD}
                        selectedFormId={{selectedFormId}}
                    />
                )}
                {isShowExportMenu && (
                    <RenderExportMenu
                        action={Constant.BULK_ACTION.EXPORT_CSV}
                        setIsShowExportMenu={setIsShowExportMenu}
                        setIsOpenDialogConfirm={setIsOpenDialogConfirm}
                        currentSearchParams={currentSearchParams}
                    />
                )}

                {/* Render ticket knowledge list */}
                <div className="list-ticket-knowledge" onScroll={e => handleOnScroll(e)}>
                    {!Utils.isEmptyArray(ticketKnowledgeList) &&
                        ticketKnowledgeList.map((ticketKnowledge, index) => {
                            return renderTicketKnowledgeItem(ticketKnowledge);
                        })}
                    {!isLoading && Utils.isEmptyArray(ticketKnowledgeList) && (
                        <div className="listEmpty listEmpty-qa">
                            <span className="listEmpty-item">
                                <img src="/assets/image/icon-listEmpty.svg" alt="" />
                            </span>
                            {trI18n('COMMSG001')}
                        </div>
                    )}
                </div>
            </div>
        );
    };


    const renderListView = () => {
        let listViewShow = listView.filter(x => {
            const structure = Utils.convertJSONDataToObject(x.structure);
            if (structure.ticketProperty === Constant.TICKET_PROPERTY.SYNONYM) {
                const limitValue = corporationDetail.limitValue;
                let synonymSearch = limitValue?.synonymSearch;

                const projectSetting = Utils.convertJSONDataToObject(
                    projectInuseDetail?.projectSetting
                );
                
                if(corporationDetail.contractType === Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK) {
                    let inviterSetting = Utils.convertJSONDataToObject(corporationDetail?.inviterSetting);
                    synonymSearch = inviterSetting.synonymSearch;

                }

                return (
                    x.status === Constant.STATUS_VIEW.SHOW &&
                    synonymSearch === Constant.STATUS_SERVICE_PERMISSION.ON &&
                    projectSetting?.usingSynonym
                );
            }
            return x.status === Constant.STATUS_VIEW.SHOW;
        });
        let isDisplayNavTabs = listViewShow.length <= Constant.LIST_VIEW_TICKET_HELP_DESK;
        let listViewOption = listView;

        if (
            !Utils.isEmptyObject(organizationProject) &&
            organizationProject.value !== Constant.KNOWLEDGE_VIEW_OPTION.ALL_KNOWLEDGE_IN_ORG
        ) {

            const curentProjectSetting = Utils.convertJSONDataToObject(projectInuseDetail?.projectSetting);
            if(!Utils.isEmptyObject(curentProjectSetting)) {
                let usingSynonym = curentProjectSetting?.usingSynonym;
                let limitValue = corporationDetail.limitValue;
                let synonymSearch = limitValue?.synonymSearch;
                if(corporationDetail.contractType === Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK) {
                    let inviterSetting = Utils.convertJSONDataToObject(corporationDetail?.inviterSetting);
                    synonymSearch = inviterSetting.synonymSearch;
                }
                if (synonymSearch != Constant.STATUS_SERVICE_PERMISSION.ON || !usingSynonym) {
                    listViewOption = listView.filter(view => {
                        let structure = Utils.convertJSONDataToObject(view.structure);
                        return structure.ticketProperty !== Constant.TICKET_PROPERTY.SYNONYM;
                    });
                }
            }

            return (
                <div className="navTabs navTabs-flex">
                    <div className="navTabs-group">
                        <DialogViewNameError 
                            setIsOpenDialogViewNameError={setIsOpenDialogViewNameError}
                            inputViewNameRef={inputViewNameRef}
                            isOpenDialogViewNameError={isOpenDialogViewNameError}
                            viewNameErrorType={viewNameErrorType}
                        />
                        <DialogNoticeViewChanged {...argsCommon} setIsScrollNewViews={setIsScrollNewViews}/>

                        <DraggableViewsList
                            tabs={listViewShow}
                            viewSelected={viewSelected}
                            isViewFromKnowledgePanel={organizationProject.value}
                            setFileNamePdfSelect={setFileNamePdfSelect}
                            setScrollToViewFunction={setScrollToViewFunction}  // Pass setter
                            scrollToViewFunction={scrollToViewFunction}        // Pass function
                            {...argsCommon}
                        />
                    </div>
                    <div className="btnTabs-wrap">
                        {!isDisplayNavTabs && <SeemoreViewKnowledgeList {...argsCommon} listViewShow={listViewShow} /> }
                        { checkDisplayBtnAddView( isCustomer, userRoleInProject, viewStructure, organizationProject, setIsCustomer) && (
                            <div className="btnAdd-viewTabs">
                                <IconButton
                                    className="btnAdd-views"
                                    onClick={event => setAddViewPopover(event.currentTarget)}
                                >
                                    <img src="/assets/image/icon-add-plus.svg" alt=""/>
                                </IconButton>

                                <Popover
                                    className="viewList-action"
                                    id={id}
                                    open={isOpenFormTypePopover}
                                    anchorEl={addViewPopover}
                                    onClose={e => setAddViewPopover(null)}
                                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center'}}
                                    transformOrigin={{ vertical: 'top', horizontal: 'center'}}
                                >
                                    <div className="add-view-more">
                                        <List>
                                            {
                                                isShowAddNewView() &&
                                                (
                                                    <ListItem disablePadding onClick={onClickAddNewView}>
                                                        <ListItemText primary={tr('新規追加')} />
                                                    </ListItem>
                                                )
                                                 
                                            }

                                            <ListItem disablePadding onClick={handleClickOpenListViewHide} >
                                                <ListItemText primary={tr('非表示ビュー一覧')} />
                                                {openListViewHide ? <ExpandLess /> : <ExpandMore />}
                                            </ListItem>
                                            <Collapse in={openListViewHide} timeout="auto" unmountOnExit>
                                                <List className="listView-hide">
                                                    {!Utils.isEmptyArray(listViewOption) &&
                                                        listViewOption.map(view => {
                                                            let viewName = getViewDisplayName(view);
                                                            return (
                                                                view.status === Constant.STATUS_VIEW.HIDDEN && (
                                                                    <ListItem key={view.id} onClick={() => onHandlerShowView( view, argsCommon)}>
                                                                        <Tooltip title={viewName} placement="right" arrow interactive >
                                                                            <ListItemText primary={viewName} />
                                                                        </Tooltip>
                                                                    </ListItem>
                                                                )
                                                            );
                                                        })}
                                                </List>
                                            </Collapse>
                                        </List>
                                    </div>
                                </Popover>
                            </div>
                        )}
                        {permissionCreateTicketKnowledge( organizationProject ) && (
                            <>
                                <Tooltip title={trI18n('CREATE_NEW')}>
                                    <button
                                        className="btn-add-ticket"
                                        onClick={() => handleClickCreateTicketType( Constant.TICKET_TYPE.KNOWLEDGE, argsCommon, props, isCustomer)}
                                    >
                                        <img src="/assets/image/icon-add-ticket.svg" alt="icon-add-ticket" />
                                        <span className="text-add-ticket">{trI18n('CREATE')}</span>
                                    </button>
                                </Tooltip>
                            </>
                        )}

                    </div>
                </div>
            );
        }
    };

    const onChangeSelectedOption = async (selectedValue) => {
        let orgData = {...organizationProject};
        orgData.value = selectedValue;

        let selectedPrjId = selectedValue;
        
        if (selectedValue === Constant.KNOWLEDGE_VIEW_OPTION.PRJ_IN_USE) {
            orgData.corpId = corporationDetail.id;
            orgData.label = trI18n('CM-LABEL-PRJ-IN-USE');
            selectedPrjId = projectInuseDetail.id;
            
            setVisibilityKnowledgeAtom(Constant.VISIBILITY_SETTING_TYPE.PROJECT);
            setIsShowVisibilityKnowledgeAtom(true);
            setProjectSelectedId(selectedPrjId);
            setOrganizationProject(orgData);
            setCorporationSelectedId(orgData.corpId);
            setIsCustomer(false);
            
            // reset view
            setViewStructure(prev => ({
                ...prev,
                visibility: Constant.VISIBILITY_SETTING_TYPE.PRIVATE,
                ticketCreatedProjectId: selectedPrjId
            }));

            setViewKnowledgeProjectSelected(prev => ({
                ...prev,
                projectId: projectInuseDetail.id
            }));
            setDestinationPrjId(selectedPrjId);

        }
        if (selectedValue === Constant.KNOWLEDGE_VIEW_OPTION.ALL_KNOWLEDGE_IN_ORG) {
            orgData.corpId = corporationDetail.id;
            let visibility = Constant.VISIBILITY_SETTING_TYPE.IN_ORG;
            if (orgData.corpId === corporationDetail.id && userPermissionView?.type === Constant.USER_PERMISSION_VIEW_KNOWLEDGE.B2C) {
                visibility = Constant.VISIBILITY_SETTING_TYPE.CUSTOMER;
            }

            orgData.label = trI18n('CM-LABEL-ALL-KNOWLEDGE-IN-ORG');
            setIsShowVisibilityKnowledgeAtom(false);
            setVisibilityKnowledgeAtom(visibility);
            setProjectSelectedId(selectedPrjId);
            setCorporationSelectedId(orgData.corpId);
            setOrganizationProject(orgData);
            // reset view
            setViewStructure(prev => ({
                ...prev,
                options : {
                    sort: Constant.DRILLDOWN_SEARCH_OPTION_SORT_TYPE.UPDATED_AT
                },
                visibility: visibility,
                ticketCreatedProjectId: ''
            }));

            setViewKnowledgeProjectSelected(prev => ({
                ...prev,
                projectId: Constant.KNOWLEDGE_VIEW_OPTION.ALL_KNOWLEDGE_IN_ORG
            }));

            setDestinationPrjId('');
        }
        if (
            ![
                Constant.KNOWLEDGE_VIEW_OPTION.PRJ_IN_USE,
                Constant.KNOWLEDGE_VIEW_OPTION.ALL_KNOWLEDGE_IN_ORG
            ].includes(selectedValue)
        ) {
            let listProject = [
                ...organizationProject?.internalProjectList,
                ...organizationProject?.externalProjectList
            ];
            const foundProject = listProject.find(prj => prj.value === selectedValue);
            if (!Utils.isEmptyObject(foundProject)) {
                orgData.label = foundProject.label;
                orgData.prjId = foundProject.id;
                orgData.corpId = foundProject.corpId;

                let visibility = Constant.VISIBILITY_SETTING_TYPE.IN_ORG;
                if (foundProject.corpId !== corporationDetail.id || (foundProject.corpId === corporationDetail.id && userPermissionView?.type === Constant.USER_PERMISSION_VIEW_KNOWLEDGE.B2C)) {
                    visibility = Constant.VISIBILITY_SETTING_TYPE.CUSTOMER;
                }
                setIsShowVisibilityKnowledgeAtom(false)
                setVisibilityKnowledgeAtom(visibility);

                setProjectSelectedId(foundProject.id);
                setViewKnowledgeProjectSelected({
                    projectId: foundProject.id,
                    corporationId: foundProject.corpId,
                    inviter: foundProject?.inviter
                });

                setCorporationSelectedId(foundProject.corpId);
                setOrganizationProject(orgData);

                setViewStructure(prev => ({
                    ...prev,
                    visibility: visibility,
                    ticketCreatedProjectId: foundProject.id
                }));
                setDestinationPrjId(foundProject.id);
            }
        }

        setFileNamePdfSelect('')
    };

    const renderSelectOptionByUserPermissionView = () => {
        return (
            <>
                {!Utils.isEmptyObject(organizationProject) ? (
                    <TextField
                        className="select-org-field"
                        value={organizationProject.value}
                        select
                        onChange={event =>  onChangeSelectedOption(event.target.value)}
                        InputProps={{
                            className: 'field-inout'
                        }}
                        SelectProps={{
                            MenuProps: {
                                anchorOrigin: {
                                    vertical: 'bottom',
                                    horizontal: 'left'
                                },
                                getContentAnchorEl: null,
                                className: 'selectDrop'
                            }
                        }}
                    >
                        {[
                            Constant.USER_PERMISSION_VIEW_KNOWLEDGE.MEMBER_OF_PROJECT,
                            Constant.USER_PERMISSION_VIEW_KNOWLEDGE.GUEST_PARTNER
                        ].includes(userPermissionView?.type) && (
                            <MenuItem value={Constant.KNOWLEDGE_VIEW_OPTION.PRJ_IN_USE}>
                                <OverFlowTooltipWithTabsMui
                                    className="prj-in-use"
                                    value={trI18n('CM-LABEL-PRJ-IN-USE')}
                                />
                            </MenuItem>
                        )}

                        {[
                            Constant.USER_PERMISSION_VIEW_KNOWLEDGE.MEMBER_OF_PROJECT,
                            Constant.USER_PERMISSION_VIEW_KNOWLEDGE.PERSONAL_PROJECT
                        ].includes(userPermissionView?.type) && (
                            <MenuItem value={Constant.KNOWLEDGE_VIEW_OPTION.ALL_KNOWLEDGE_IN_ORG}>
                                <OverFlowTooltipWithTabsMui
                                    className="all-knowledge-in-org"
                                    value={trI18n('CM-LABEL-ALL-KNOWLEDGE-IN-ORG')}
                                />
                            </MenuItem>
                        )}

                        {!Utils.isEmptyArray(organizationProject.internalProjectList) && (
                            <MenuItem disabled className='list-kn-menu-label'>
                                <OverFlowTooltipWithTabsMui
                                    className="internal-prj"
                                    value={trI18n('CM-LABEL-INTERNAL-PRJ')}
                                />
                            </MenuItem>
                        )}
                        {!Utils.isEmptyArray(organizationProject.internalProjectList) &&
                            organizationProject.internalProjectList.map((option, index) => (
                                <MenuItem key={index} value={option.value}>
                                    <OverFlowTooltipWithTabsMui
                                        className="prj-select-option"
                                        value={option.label}
                                    />
                                </MenuItem>
                            ))}

                        {[
                            Constant.USER_PERMISSION_VIEW_KNOWLEDGE.MEMBER_OF_PROJECT,
                            Constant.USER_PERMISSION_VIEW_KNOWLEDGE.GUEST_PARTNER,
                            Constant.USER_PERMISSION_VIEW_KNOWLEDGE.GUEST_SUPPORTED
                        ].includes(
                            userPermissionView?.type
                        ) &&
                            !Utils.isEmptyArray(organizationProject.externalProjectList) && (
                                <MenuItem disabled className='list-kn-menu-label'>
                                    <OverFlowTooltipWithTabsMui
                                        className="external-prj"
                                        value={trI18n('CM-LABEL-EXTERNAL-PRJ')}
                                    />
                                </MenuItem>
                            )}
                        {!Utils.isEmptyArray(organizationProject.externalProjectList) &&
                            organizationProject.externalProjectList.map((option, index) => (
                                <MenuItem key={index} value={option.value}>
                                    <OverFlowTooltipWithTabsMui
                                        className="prj-select-option"
                                        value={option.label}
                                    />
                                </MenuItem>
                            ))}
                    </TextField>
                ) : (
                    <></>
                )}
            </>
        );
    };

    return (
        <div className="mainWrap">
            <LoadingPanel isLoading={isLoading || isLoadingView || isIsnitData} />
            {!Utils.isEmptyObject(organizationProject) && (
                <>
                    <div className="customMainTopKnowledge">
                        <div className="navSelect">
                            <div className="navSelect-org">
                                {renderSelectOptionByUserPermissionView()}
                            </div>
                        </div>
                        {renderListView()}
                    </div>
                    <div className="contentTab">{renderContentTab()}</div>
                </>
            )}

            {/* Dialog / Popup */}
            <AlertDialog isOpen={isOpenAlertDialog} setIsOpen={setIsOpenAlertDialog} />
            <DataChangePleaseReloadModal
                {...argsCommon}
                content={contentModalReloadPage}
                isOpen={isOpenModalReloadPage}
                setIsOpen={setIsOpenModalReloadPage}
            />
            <ConfirmDialog
                isOpen={isShowDialogNotiLimit}
                msgConfirm={limitNotiMessage ? limitNotiMessage : trI18n('MSG-CM-EXCEED-MAX-CONTENT-BULK-ACTION')}
                okCallBack={() => {
                    setIsShowDialogNotiLimit(false);
                    setLimitNotiMessage('');
                }}
            />
            <ConfirmDialog
                isOpen={isShowPopupLogout}
                msgConfirm={<div><span>{trI18n('MSG-CM-EXPIRED-SESSION-1')}</span><br/><span>{trI18n('MSG-CM-EXPIRED-SESSION-2')}</span></div>}
                textSubmit={trI18n('COMBTN004')}
                okCallBack={() => signOut()}
                cancelCallBack={() => setIsShowPopupLogout(false)}
                cancelClassName={'btn-confirm-cancel'}
            />

            <Dialog
                open={!!openPreviewImage}
                onClose={() => setOpenPreviewImage(null)}
                maxWidth="md"
            >
                <img
                    alt=""
                    src={openPreviewImage}
                    style={{
                        maxWidth: '90vw',
                        maxHeight: '90vh',
                        objectFit: 'contain'
                    }}
                />
            </Dialog>

            <ConfirmDialog
                isOpen={isShowDialogReload}
                msgConfirm={trI18n('COMMSG030')}
                okCallBack={() => window.location.reload()}
            />
        </div>
    );
}
